import React from "react";
import LayoutMensajesVirgen from "../components/LayoutMensajesVirgen";
import EsquinerosArriba from "../components/EsquinerosArriba";
import EsquinerosAbajo from "../components/EsquinerosAbajo";

export default function MensajesVirgenEs() {
  return (
    <>
      <LayoutMensajesVirgen>
        <div className="container px-md-4" id="1990">
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Mensajes dados por <br /> La Santísima Virgen
              </h3>
              <h5>13/07/1990 al 31/12/1994</h5>
              <h5>Salta - Argentina</h5>
            </div>
            <div className="col-12 mt-5">
              <h6>13 de Julio de 1990</h6>
              <p>
                Nuestra <strong>SEÑORA DE LAS LAGRIMAS</strong>, te dirá lo que
                quiere el día 16, debes rezar mucho por los pecadores, por los
                afligidos, por los que sufren. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6 className="mensajes">
                31 de Julio de 1990 (estando en oración)
              </h6>
              <p>
                <strong>LA INMACULADA CONCEPCION</strong> dijo: “Haré una gran
                manifestación, para que todos te crean”.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>11 de Agosto de 1990</h6>
              <p>
                ( Después de consagrarme al Señor, la Santísima Madre abrió sus
                brazos y sonriéndome con mucha alegría dijo): “Ven hija mía,
                Alabado sea el Señor, los Ángeles te acompañarán, el Señor
                abrirá un camino de luz”.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>Jueves 16 de Agosto de 1990</h6>
              <p>
                María: Debes rezar por la paz del mundo que está amenazada, por
                los pecadores, por los que sufren, por los afligidos. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>Viernes 17 de Agosto de 1990</h6>
              <p>
                La <strong>SEÑORA DE LAS LAGRIMAS</strong> me envía a deciros
                que: <br />
                “Pronto estaré con ustedes, debo ayudar a los que me necesitan,
                hay muchos hijitos que sufren por la situación angustiosa, a
                ellos daré mi Misericordia, necesito un lugar donde también esté
                mi Hijo Bendito, junto a su Iglesia. Allí haré grandes cosas
                ¡Que sea pronto, hay muchos necesitados!”. <br />
                Os bendeciré. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>31 de Agosto de 1990</h6>
              <p>
                Hijos míos: <br />
                El Rosario no debe usarse como amuleto de la suerte, mediante el
                rezo diario del Santo Rosario, invocamos la protección divina y
                reverenciamos a Dios. <br />A nuestros queridos jóvenes, les
                pido que vuelvan sus ojos a Jesús, para salvar al mundo del
                pecado en que está sumergido. <br />
                La oración diaria y sencilla, agrada a Nuestro Señor más que
                nada. <br />
                Rezad todos con gran devoción y se os dará la paz a los
                espíritus que se prepararán para el Señor. <br />
                Os bendeciré. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 de Setiembre de 1990</h6>
              <p>
                Hija mía: <br />
                Debes rezar cada día el Santo Rosario, al elevar esta plegaria a
                Dios, por la humanidad doliente, me haces muy feliz. <br />
                Esa será la forma en que me darás a conocer a los corazones que
                me tienen olvidada, y YO haré grandes cosas por todos mis hijos,
                cuando me alaben, y alaben a Dios a través mío. <br />
                Os bendeciré. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 de Setiembre de 1990</h6>
              <p>
                Hijos míos: <br />
                Orad al Padre, que El os escuchará, Jesús vino, oró con ustedes,
                aprended de El que es todo Amor al Padre. <br />
                En la oración está el Camino, la Verdad, la Vida, y El, os
                iluminará para que lleguéis a El. <br />
                No temáis, los que oran al Padre con devoción, porque ellos lo
                encontrarán. <br />
                A través de mi Divino Hijo. De su fuente beberán, los que oren y
                no pequen. <br />
                Os bendeciré. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 de Septiembre de 1990</h6>
              <p>
                Hijos míos: <br />
                “El mundo adora al dios baal, él es, el materialismo. Dios
                quiere esparcir su Misericordia en esta tierra y en el mundo,
                por eso les pide que busquen “SU MISERICORDIA”. Los jóvenes
                adoran a baal, ellos caerán poco a poco en el abismo insondable
                del mal. Convertíos todos a Dios”. <br />
                Debes dar a conocer este mensaje, la MISERICORDIA está dando una
                gran oportunidad al mundo, pronto, puede ser muy tarde. “No
                temas María” <br />
                Os bendeciré. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 de Setiembre de 1990 (en oración)</h6>
              <p>
                María: <br />
                Yo te iré revelando lo que deseo en el momento que sea
                necesario, entretanto la oración y la penitencia es lo que pide
                Dios, para el perdón de los pecados, sin oración no hay
                arrepentimiento. <br />
                María: El mundo está al borde del genocidio. Mi alma está
                triste, sube hasta el Cielo el clamor de las voces, para acallar
                estas, que suban las de oración. Recen, recen, ¡Pobres mis
                hijos, pobres hijos! <br />
                Os bendeciré Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>Octubre de 1990</h6>
              <p>
                María hija mía: <br />
                Pronto se desatará una guerra que será muy cruenta.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 de Octubre de 1990</h6>
              <p>
                María hija mía: <br />
                Quiero que reces por la Paz del mundo y que hagas penitencia y
                se la ofrezcas al Señor tu Dios. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>23 de Octubre de 1990</h6>
              <p>
                ( mientras rezaba el rosario) <br /> <br />
                En este día tuve una visión de la Santísima Madre, toda de
                blanco de la cabeza a los pies. Primero extendió sus brazos, y
                de sus manos salieron, luces extraordinariamente blancas y
                transparentes. Su semblante hermosísimo, estaba intensamente
                triste y su rostro hacia abajo. Luego juntó sus manos en actitud
                de oración y mirando hacia arriba, se fue sin pronunciar una
                sola palabra.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 de Diciembre de 1990</h6>
              <p>
                ( estando en oración la Santísima Madre dijo): <br />
                <strong>
                  “YO SOY MARIA, MADRE DE TODOS LOS DOLORES y NUESTRA SEÑORA DE
                  LAS LAGRIMAS”
                </strong>
                <br />
                Me habló de todas las ofensas que se hacen al Señor
                permanentemente, y me mostró el Divino CORAZON DE JESUS coronado
                de espinas.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>9 de Setiembre de 1991</h6>
              <p>
                Hija:
                <br />
                La oración es el lazo de unión, entre Dios y los hombres. <br />
                Una mañana al despertar y al ponerme en oración, tuve una visión
                de Jesús en la cruz, y El dijo: <br />
                <strong>“Tengo sed, dame de beber”</strong>
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>11 de Marzo de 1992 (en oración)</h6>
              <p>
                Hija: <br />
                Escucha el mensaje de tu Madre que llora por tantos hijos
                descarriados. Quiero que reces sin parar ¡Cuantos pecados con
                que se ofenden al Señor! y pensar que El murió y se entregó por
                todos vosotros, en muerte de Cruz, indignos sois del Señor.{" "}
                <br />
                Recen todos para que el mundo se convierta. <br />
                Haced oración, haced penitencia, mirad la Gloria de Jesucristo,
                leed el Evangelio, practicad la Palabra de Dios, con sinceridad
                de corazón. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>4 de Julio de 1994</h6>
              <p>
                A la mañana muy temprano mientras hacía mis oraciones, vi frente
                a mi, un ANGEL, al verlo sentí un gran gozo, dentro y fuera de
                mi, un profundo gemido se escapó de mi boca ante la presencia de
                este Ángel de extraordinaria belleza, no era solo su belleza lo
                que realmente me impresionó, sino que de su presencia emanaba un
                gran gozo y me lo transmitía, haciéndome sentir una gran dicha
                interior, muy difícil de explicar con palabras. El estaba
                vestido de blanco y llevaba un cordón atado en su cintura, y su
                aspecto era recio y resplandeciente; al verlo me pareció un
                joven de 17 años, sus cabellos eran rubios y el largo justo
                debajo de las orejas. <br />
                Llevaba en una de sus manos una vara larga que sobrepasaba su
                cabeza, y la apoyaba sobre el suelo. <br />
                El se paró frente a mi y por un tiempo (no sé cuanto) no dijo
                nada, sólo me miraba firmemente y con mucha insistencia. <br />
                Le pregunté <br />
                ¿Quien eres? <br />
                R: Soy un Ángel, pertenezco a la guardia real de las legiones
                celestiales, a las órdenes de San Miguel Arcángel, en la lucha
                contra satanás. <br />
                Después me dijo: <br />
                Escucha atentamente y presta atención. ¿Acaso creen que El Señor
                Dios permitirá que se sigan cometiendo abominaciones en su
                Casa?. Dios es un Padre que corrige. Su AMOR alcanza a buenos y
                malos, su paciencia es Infinita, todavía la ira de Dios no se ha
                desatado contra los despiadados, porque solo El, es el Creador
                de todo lo que existe, El, es el poder sobre todo poder, su
                Misericordia es infinita, el Amor de Dios es Salvador. <br />
                ¡Feliz de ti que obras bien, bienaventurados sean tus pesares!
                (se quedó callado como esperando que le hable) yo le pregunté:{" "}
                <br />
                ¿Que quieres que haga? <br />
                R: Yo soy un servidor, EL que ES, me envía, sé buena servidora,
                haz lo que yo hice. <br id="1995" />
                Alabado y Glorificado sea el Señor por siempre, Bendito y
                Alabado.
              </p>
            </div>
          </div>
        </div>
        <EsquinerosAbajo />
        <EsquinerosArriba />
        <div className="container px-md-4" id="1995">
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Mensajes dados por <br /> La Santísima Virgen
              </h3>
              <h5>1995</h5>
              <h5>Salta - Argentina</h5>
            </div>
            <div className="col-12 mt-5">
              <h6>13 DE MARZO DE 1995</h6>
              <p>
                ( mientras rezaba el rosario, misterios Gloriosos) <br /> <br />
                Este día tuve una visión de la Santísima Virgen, NUESTRA SEÑORA
                DE SHOENSTTAT Madre, Reina y Victoriosa. <br />
                La Virgen y el Niñito Dios cobraron vida en el cuadro, Ella, la
                Santísima Virgen, estaba muy sonriente y el Niñito también en
                medio de una gran y radiante luz, el Divino Niño Jesús en sus
                brazos acariciaba amorosamente con su manito el rostro de la
                Santísima Virgen, luego el Niño se agachó, besó sobre el Corazón
                de María y luego entró su manito en el pecho de la Virgen, tomó
                entre sus manos amorosamente el Corazón de la Virgen, luego los
                sostuvo delante de ellos con una manito como ofreciéndolo, y
                mientras hacía esto, con su otra manito bendijo sobre el Corazón
                Inmaculado de la Virgen a toda la ciudad y el mundo. <br />
                Siempre sus rostros estuvieron sonrientes y alegres inspirando
                una gran confianza, luego se fue la visión. <br />
                Después de esto mi alma quedó muy extasiada, con gran gozo y paz
                interior. <br />
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 de Marzo de 1995</h6>
              <p>
                María hija mía: <br />
                Debes confiar siempre en el Sacratísimo Corazón Eucarístico de
                mi Hijo Jesús, quiero que te dirijas a El constantemente en
                todas tus oraciones, hoy te pido hija de mi Corazón que ores
                mucho por los enfermos y trates de que cada alma y cada corazón,
                sea atraído con fuerza hacia el Corazón de Cristo; El Cristo que
                sufre por cada uno de ustedes, especialmente por los enfermos;
                absórbete en la Pasión, paso a paso y pide por los pecadores,
                concéntrate hija mía, en las almas vacías y trata de llenarlas
                con tu oración para que Jesús pueda penetrar en ellas. <br />
                Es todo por hoy hija, Alabado sea el Nombre de mi Hijo Jesús.{" "}
                <br />
                Amén. <br />
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>22 DE MARZO DE 1995</h6>
              <p>
                Queridos hijos: <br />
                Hoy quiero protegerlos del maligno, satanás obra, él tratará de
                dominarlos inclusive a través de personas, aún de las que están
                en la Iglesia, satanás y sus espíritus malignos, no se darán a
                conocer fácilmente sino que se encubrirán con piel de corderito,
                y sutilmente sembrarán el mal especialmente, él atacará a la
                Iglesia y a todos los lugares donde se enseñe la Palabra de mi
                Divino Hijo Jesús, se instalará en esos lugares para tratar de
                perderlos y en su trampa mortal pueden caer muchos,
                especialmente los que no vigilen la entrada de su corazón por
                eso les pido permanentemente, el ayuno, la oración, la
                penitencia, mortifiquen el cuerpo para fortaleceros
                interiormente, os hablo a todos, permanezcan vigilantes porque
                satanás los vigila y espera siempre la oportunidad para
                perderlos. <br />
                Os digo esto, no para atemorizarlos, sino para prevenirlos,
                prepárense así como se prepara la tierra para la siembra, día a
                día con constancia, alaben a Dios en cada cosa que hagan,
                bendigan el Nombre del Señor. <br />
                Que Dios los bendiga mis hijos. <br />
                Amén. <br />
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>1 DE ABRIL 1995</h6>
              <p>
                En este día mientras hacía el vía crucis (en mi dormitorio, tuve
                la siguiente visión) <br /> <br />
                Vi delante del Sagrario de la parroquia, el Corazón herido de
                Jesús, el Corazón tenía una profunda herida, y cuando latía, de
                la herida salía una gota gruesa de Sangre que se derramaba. A la
                vez El Señor me daba a conocer el sufrimiento que había en ese
                espasmo, al salir las gotas de Sangre, dolor físico y moral, era
                algo tan inenarrable ese dolor, que al transmitírmelo El Señor,
                yo no pude soportarlo y comencé a desmayarme, y sentí que mi
                corazón no resistiría, pero El Señor me lo quitó, pues de no
                haberlo hecho yo habría muerto. <br />
                El Señor me mostró cuanto AMOR hay en su Corazón Adorado,
                ¡Cuanto AMOR guarda El en el Sagrario VIVO y PRESENTE! ¡Inmenso,
                Infinito AMOR por nosotros, sufriendo a través de los siglos Su
                Pasión Salvadora!. <br />
                La Trinidad Santa, está presente en el Sacratísimo Corazón
                Eucarístico de Jesús. <br />
                Luego de terminar esta visión aparecen estas palabras: <br />
                “YO SOY EL SACRATISIMO CORAZON EUCARISTICO DE JESUS, ADORADME
                PERPETUAMENTE EN REPARACION”; y me inspiró la siguiente oración
                para ser rezada a los pies del Sagrario. <br />
                <br />
                Sacratísimo Corazón Eucarístico de Jesús, Yo Confío inmensamente
                en Tu Misericordia. Te pido humildemente que me des la fe que
                necesito para abandonarme a tu Infinita Misericordia, por que ya
                se han agotado mis recursos humanos y ahora sólo me cabe
                volverme con confianza a tu Infinita Compasión, porque sé que TU
                no desoirás mi súplica. Aquí estoy Señor a tus pies pidiendo con
                fervor arregles todas mis cosas y problemas, según tu Amor y
                beneplácito divino, que sé, será lo mejor para mí, concédeme lo
                que te estoy pidiendo, si es para bien de mi alma. <br />
                ¡Toma Señor! Mi problema. <br />
                ¡Toma, mi corazón ! Yo confío en Tí, Corazón Eucarístico de
                Jesús. <br />
                ¡Yo Confío en Tí Corazón Eucarístico de Jesús! <br />
                ¡Yo Confío en Tí Corazón Eucarístico de Jesús!
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>21 DE ABRIL DE 1995</h6>
              <p>
                (En el Santuario de Nuestra. Sra. Shoensttat) <br />
                <br />
                En este día mientras adoraba a Jesús Sacramentado, la Santísima
                Virgen dijo: <br />
                Queridos hijos: <br />
                Hoy he venido a ustedes para pedirles que oren, y oren por todas
                las personas que están necesitadas, por los que son perseguidos,
                por los que sufren hambre y desamparo, por los afligidos y
                enfermos, por los niños víctimas del mundo, que caminan en un
                mar de maldad, contaminado por el pecado; si no oran, mis
                queridos hijos, la humanidad camina hacia su destrucción,
                ustedes son los elegidos, para que por medio de la oración
                puedan detener el castigo que les espera. <br />
                Oren al Padre que está en los Cielos, háganlo en Nombre de su
                Hijo Jesucristo. <br />
                <br />
                Oración, Oración, Oración, escuchen a esta Madre del Cielo que
                sabe como salvar a sus hijos, sean humildes mis hijos, para que
                vuestra oración llegue al Cielo. <br />
                <br />
                Bendito y alabado sea Dios. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>10 DE MAYO DE 1995</h6>
              <p>
                Mensaje de Jesús. <br />
                <br />
                Cuando llegue el día del juicio, todos resucitarán, os lo
                aseguro, desde el primer hombre Adán y Eva, la primera mujer, y
                con ellos el último de los últimos y en ese día toda la creación
                estará expectante, cielos y tierra se verán. <br />
                El Padre, El Hijo y El Espíritu Santo, la Gloria de las Glorias,
                benditos serán los benditos y malditos los malditos. <br />
                Os he enviado a María mi Madre, el que la escucha a Mi me
                escucha. <br />
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>11 DE MAYO DE 1995</h6>
              <p>
                Al preguntarle a la Virgen, sobre la “mujer”.
                <br />
                <br />
                ¡Tú eres una mujer!, el anhelo más grande de mi Corazón, es que
                nunca al pensar en Mi, me separen de mi Hijo Jesús, he sido
                desde el vientre de mi madre, concebida por El, nacida para El,
                mi vida para El, con El y en El, y ahora que estoy con El todo
                mi Cielo es EL. <br /> <br />
                Mujeres del mundo, el tercer milenio se aproxima, es la mujer la
                que se adueñará de este tiempo. Sean fuertes que no se pierda la
                esencia que en vosotros vino cuando Dios os regaló la vida.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>13 DE JUNIO DE 1995</h6>
              <p>
                Mensaje de Jesús. <br />
                <br />
                El mundo nunca se preguntó, cuantas lágrimas derramé por
                vosotros durante mi Pasión y cuantas y amargas lágrimas derramó
                mi Santa Madre, para ayudar a la Redención, Yo les pido que
                honren cada lágrima que por vosotros derramé en esas horas
                amargas, prometo al que las honre rezando todos los días de su
                vida cinco Padrenuestros, cinco Avemarías y cinco Gloria. <br />{" "}
                <br />
                <strong>1)</strong> Asistirle junto a mi Santísima Madre, en la
                batalla final de su vida. <br />
                <strong>2)</strong> La conversión total de su alma. <br />
                <strong>3)</strong> Una verdadera contrición de sus pecados.{" "}
                <br />
                <strong>4)</strong> En el día del juicio, perdonarlo para que
                entre Conmigo en la Gloria.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>9 DE AGOSTO DE 1995</h6>
              <p>
                Amados hijos: <br />
                Que la Paz y el Amor del Señor esté con todos ustedes. <br />
                Hoy he venido a pedirles que todos los días recen el Santo
                Rosario, para comenzar vuestra conversión, el segundo paso será
                la enmienda de vuestras almas, mediante el Santo Sacramento de
                la Confesión y la Santa Misa, los que podáis, asistid todos los
                días sin faltar los domingos perseverad en el rezo diario del
                Santo Rosario, este medio tan sencillo de oración, transformará
                vuestras vidas, sean perseverantes en el cumplimiento de estos
                tres pedidos y pronto os veréis transformados; tal vez al
                comienzo cueste un poco, pero si lo hacéis os prometo grandes
                Gracias cumplid pronto este pedido mío, es urgente la
                conversión, quiero tener a todos mis hijos; ¡Las puertas del
                Cielo están abiertas para todos! <br /> <br />
                ¡Abrid vuestros corazones! Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>15 DE AGOSTO DE 1995</h6>
              <p>
                María hijita de mi Corazón: <br />
                Quiero que mires a el Cielo, donde habito en cuerpo y alma
                Gloriosos, en compañía de los Ángeles y los Santos ; Mírame hija
                mía (ella me miró y abrió sus manos las extendió y salieron
                relámpagos de luces purísimas) y dijo: <br />
                <br />
                Solo contempla mi dicha , participa mi hija de ella, es el
                regalo de tu Madre del Cielo que quiere compartir contigo.{" "}
                <br />
                Mi alma alaba la grandeza del Señor y mi espíritu se regocija en
                la Gloria de Dios, eternas son las Misericordias del Señor mi
                Dios y Salvador, felices los que esperan en El Señor, porque
                ellos serán saciados en el manantial de agua viva y nunca más
                tendrán hambre ni sed porque verán a Dios. <br />
                Se humilde hija, predica la humildad, has sostenido una gran
                batalla, no temas. Yo estaré contigo hasta el fin, soy Hostia
                Santa en tu corazón. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>5 DE SEPTIEMBRE DE 1995</h6>
              <p>
                Mis hijos: <br />
                No os rebeléis a vuestro Padre que está en el Cielo, por el
                contrario procurad, siempre darle gracias y alabanzas, sufrirlo
                todo con gran resignación y paciencia, ya que la virtud de la
                paciencia es la que os Santificará, ofrézcanle todo a Nuestro
                Señor, no busquen las cosas vanas de este mundo, sino por el
                contrario hagan oración, recen el Santo Rosario, cuantas veces
                puedan, mientras más rezan más gracias alcanzarán. Si no rezan y
                se confiesan, por lo menos una vez al mes, ustedes no crecen
                espiritualmente, y le .dan lugar al adversario, al encontrarlos
                con pocas fuerzas. <br /> <br />
                ¡Conviértanse todos mis hijos! Da a conocer esto. Amén. Aleluya.
                Amén. <br />
                <br />
                Que Dios los bendiga.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>6 SEPTIEMBRE DE 1995</h6>
              <p>
                ¿Por qué quedan guardados mis mensajes? Ezequiel cap. 15 cap. 32
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>25 DE SETIEMBRE DE 1995</h6>
              <p>
                Amados hijos: <br />
                Os hablo a todos mis hijos que hoy se han reunido en tantos
                lugares para venerarme, ¡¡Estoy tan Contenta!! por que veo a
                cada uno de ustedes, os escucho a cada uno en particular, veo
                las manos que se extienden pidiéndome Gracias, Yo os prometo
                llevar todos vuestros pedidos al Cielo y depositarlos a los pies
                de la Santísima Trinidad, Yo soy vuestra abogada, poderosa
                intercesora ante el Trono de Dios. Os pido Oración y
                Reconciliación, al que cumpla con este pedido mío, Yo
                intercederé para que reciban la paz verdadera del amoroso
                CORAZON DE JESUS y la sanación del alma. <br />
                <br />
                Quiero reiterar mi pedido en este día tan especial, CONSAGRENSE
                TODOS AL INMACULADO CORAZON DE MARIA por que mi Corazón
                Inmaculado triunfará y ustedes los que se consagren, triunfarán
                con él; y conságrense a mi Corazón con el rezo diario del Santo
                Rosario Ay mis hijitos, si supieran todo lo que reciben cuando
                rezan con devoción el Santo Rosario. <br />
                <br />
                ¡Alégrense en la esperanza los que se vuelven a Dios! <br />
                Bendito y alabado sea el SACRATISIMO CORAZON EUCARISTICO DE
                JESUS. <br />
                Bendito y Alabado sea JESUS EUCARISTIA. <br />
                Bendita y alabada sea LA SANTISIMA TRINIDAD presente en la
                SAGRADA EUCARISTIA. <br />
                Amén Aleluya, Amén Aleluya.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>13 DE OCTUBRE DE 1995</h6>
              <p>
                (rezando en mi dormitorio) <br />
                <br />
                Amada hijita: <br />
                Con cuanto gusto recibo todas las alabanzas, oraciones y
                lágrimas de amor por mi Divino Hijo Jesús, especialmente en este
                día. <br /> <br />
                El mundo debe Consagrarse a mi Inmaculado Corazón. Ya el tiempo
                se ha acortado, los signos avisarán que se cumplirán, todas las
                profecías que os he dado a través del tiempo, con más intensidad
                en estos últimos años para moveros a una urgente conversión a
                Dios. Mi corazón de Madre sufre por que muchas personas hacen
                oídos sordos a mis llamados urgentes de conversión.
                <br />
                <br />
                El Señor me permite por su gran Misericordia daros avisos de las
                cosas terribles que vendrán para la humanidad, en la oscuridad
                que se aproxima ya no brillará la luz. Las más terribles
                tribulaciones os esperan, las físicas a que se verán sometidos
                serán totalmente insoportables pero también vendrán las del
                espíritu que serán tan tortuosas como jamás sufrió el hombre
                desde su creación. <br />
                <br />
                El odio del adversario se desatará entonces con todo su furor y
                hará enloquecer a las naciones de la tierra. El fuego que caerá
                desde el Cielo paralizará de terror a todos y el estruendo será
                tan grande, que hará conmover a todo el Universo, después de
                esto sólo quedarán la 3/4 partes de la humanidad. <br />
                <br />
                La señal que os he anunciado se verá en favor de los elegidos.
                Dios Padre os dará tiempo para resguardaros en los lugares ya
                preparados para ese gran momento, los hijos que me habéis
                escuchado ya estarán preparados, y en ese día caed de rodillas,
                cual penitentes y orad así: <br />
                <br />
                Santísima Trinidad que tu Santísima voluntad se cumpla, Tened
                Piedad de nosotros, Tened Piedad, Tened Misericordia, Tened
                Misericordia. ¡Oh! Dios Misericordia, Misericordia. <br />
                <br />
                Por la Sangre del Cordero ten Piedad, <br />
                Por la Pasión del Cordero ten Misericordia, <br />
                Por las Llagas del Cordero ten Piedad. <br />
                Por Tu Hijo el Cordero de Dios escúchanos <br />
                Padre apiádate de nosotros por el Nombre Bendito de tu Hijo
                Jesús. Amén. <br />
                <br />
                Os pido conversión URGENTE al Inmaculado Corazón de María, para
                mitigar estos horrores que sobrevendrán por los pecados, hijita,
                el mundo está navegando en una ciena inmunda, sumergido en toda
                clase de impurezas, ya imposible de comparar, ya que nunca se
                vio algo así desde su creación. El nauseabundo olor sube denso
                hasta Dios y hay pocas almas de oración, ya el castigo está a
                las puertas. <br />
                <br />
                Mis ruegos detienen la Mano de Dios, Pido más oración,
                Especialmente de los CONSAGRADOS, que oren sin cesar y sobre
                todo di que amen a Dios, el que es SANTO, SANTO, SANTO. <br />
                <br />
                ¡Y Que el Santo Temor a Dios vuelva a los corazones! <br />
                <br />
                Los que crean estas palabras mías y se conviertan se salvarán.
                Da a conocer este mensaje hija, hoy como ayer URGENTE LLAMADO AL
                AMOR DE DIOS. <br />
                <br />
                Te bendigo hijita de mi Corazón. <br />
                Amén, Amén, Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>29 de Octubre de 1995 (estando en oración)</h6>
              <p>
                Queridos hijos: Ustedes piensan que el Cielo es un lugar lejano
                e inalcanzable. Algunos ni siquiera creen en él, hoy quiero
                decirles, queridos hijos, que el Cielo está muy cerca de
                ustedes. Yo os invito a que entren en un Templo y se acerquen al
                Sagrario y miren hacia El, y estarán contemplando el Cielo aquí
                en la tierra, porque el Cielo es JESUS, y donde El está, está el
                Cielo ¡El es DIOS! Pónganse en oración, sabiendo que El está
                presente en todos los Sagrarios del mundo. Déjense guiar por El,
                hagan todo lo que El les diga. <br />
                <br />
                Los amo a todos. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>31 de Octubre de 1995</h6>
              <p>
                Después de comulgar, tuve una visión, al cerrar los ojos para
                conversar con Jesús. El, se me apareció en el Rostro del Santo
                Sudario pero no como se ve, en una lámina o foto, sino real,
                todo su Rostro iluminado y con todos los padecimientos visibles,
                esto fue de un profundo efecto en mi alma. El, con sus Ojos
                cerrados me miraba el corazón y yo lo miraba con mi corazón.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>5 DE NOVIEMBRE DE 1995</h6>
              <p>
                Mis hijos: <br />
                Os traigo una palabra del Cielo ¡ESPERANZA! ¡ESPERANZA!
                ¡ESPERANZA! <br />
                ¿Como pueden mis hijos comprender el AMOR DE DIOS si viven en
                desesperanza? <br />
                <br />
                Piensen. <br />
                <br />
                La esperanza: es esperar en Dios y sólo en El; esperarlo todo de
                El, poniendo todos vuestros esfuerzos, pero mirando la esperanza
                que está en el Cielo. <br />
                En el AMOR que DIOS les tiene a todos ustedes está la esperanza,
                porque DIOS ES AMOR, y el AMOR DE DIOS todo lo contiene. <br />
                Alabado sea ¡Jesús!
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>6 DE NOVIEMBRE DE 1995</h6>
              <p>
                Amados hijos: <br />
                He venido a visitarlos para llenarlos de bendiciones traídas del
                Cielo, aunque a muchos de ustedes les cueste creer; por que no
                tienen fe, hijitos, si ustedes abren vuestros corazones, ésta
                Madre podrá llevarlos a la conversión, les traigo mucho Amor y
                Esperanza. <br />
                Quiero que todos escuchen mis mensajes, Yo la Madre de Jesús
                estoy muy feliz entre ustedes porque ya han comenzado a
                corresponder y pronto verán que el Señor, estará en vuestros
                corazones, especialmente los más jóvenes, en ellos he puesto la
                esperanza. <br />
                Os invito a un cambio radical en vuestras vidas, sigan con
                atención mis mensajes pues en ellos, os iré enseñando como
                acercarse a Dios. ¡Gracias por abrir vuestros corazones! <br />
                <br />
                Este es tiempo de Misericordia. <br />
                Hay una luz que brilla en medio de ustedes. Oren, Oren. <br />
                Bendito y Alabado sea el SACRATISIMO CORAZON EUCARISTICO DE
                JESUS.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>18 DE NOVIEMBRE DE 1995</h6>
              <p>
                Tomen conciencia hijos queridos que Dios está vivo, muy cerca de
                ustedes. <br />
                El, es el creador de todo cuanto ven vuestros ojos y aún más
                allá. <br />
                Quiero que comiencen a pensar seriamente en todo esto, lean la
                Santa Biblia, pidan al Espíritu Santo que los ilumine para una
                mayor, comprensión. <br />
                Amén, Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>18 DE NOVIEMBRE DE 1995</h6>
              <p>
                Anoche tuve una visión: <br />
                <br />
                Vi un jardín lleno de pimpollos de rosas blancas muy juntitas.{" "}
                <br />
                Al preguntar el significado de lo que veía se me manifestó.{" "}
                <br />
                Las rosas blancas simbolizan la pureza.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>22 DE NOVIEMBRE DE 1995</h6>
              <p>
                Trabajen, trabajen mis hijos, trabajen con alegría por el Reino
                de Dios ¡Gloria a Dios! <br />
                Amén.
                <br />
                <br />
                (En un mensaje privado) “Oración para pedir Sabiduría” <br />
                ¡Dios mío y Señor mío Misericordioso! <br />
                Dame Santa Sabiduría que procede de tu infinita bondad, <br />
                Abre los ojos de mi fe a la luz eterna, <br />
                Para que con ellos te pueda ver, por que tu Sabiduría Señor,{" "}
                <br />
                es más radiante que el sol. <br />
                Guía mis pensamientos Señor con tú Sabiduría, <br />
                para que sea la fuente de mi saber y obrar. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>25 DE NOVIEMBRE DE 1995</h6>
              <p>
                Hoy tengo una visión de la Santísima Madre, en actitud de
                profunda oración, su rostro permanece cabizbajo. Tiene sus manos
                juntas a la altura de su rostro, por unos minutos permanece en
                silencio y luego me dice. <br />
                <br />
                Queridos hijos: <br />
                Os estoy llamando a todos a la conversión y para que esto suceda
                ustedes deben orar mucho. Pidan al Espíritu Santo , por medio de
                la oración todos los días, que obre en vuestros corazones, para
                que puedan vivir como verdaderos Cristianos. <br />
                <br />
                Es la oración tan importante, como ustedes no se pueden
                imaginar. <br />
                <br />
                Ella puede abrir un inmenso canal de Gracias, si son constantes.
                Comiencen a orar hoy, para que el Amor de Dios llene todos los
                espacios de vuestros corazones. <br />
                El Espíritu Santo es el único que los puede convertir y
                llevarlos a la Santidad. <br />
                El es el comunicador de todas las Gracias que proceden del único
                SANTO, SANTISIMO, que es la SANTA TRINIDAD. Benditos sean mis
                hijos. <br />
                Amén Aleluya, Amén Aleluya.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>27 DE NOVIEMBRE DE 1995</h6>
              <p>
                Voy a tratar de explicar con palabras lo que Dios comunicó a mi
                alma sin palabras. <br />
                <br />
                Después de comulgar con el Cuerpo y Sangre de Jesús. El inmenso
                AMOR DE DIOS me invadió. Este inmenso AMOR llegó a mi alma en
                profundo silencio. El permaneció en mi y sin palabras le
                manifestó a mi corazón que este infinito AMOR de Dios y por su
                medio en nosotros, los que lo recibimos en la Santa Comunión, en
                su infinita Misericordia se comunica a todas las almas, aún a
                las que no lo reciben. Para llamarlas y darles vida, con su
                inmenso AMOR presente en la SAGRADA EUCARISTIA. <br />
                <br />
                Y EL AMOR me dice, ora así: <br />
                <br />
                ¡Oh! amor infinito que nunca cesas de llamar <br />
                ¡Oh! Pasión infinita que nunca dejas de padecer <br />
                Tú llamas <br />
                Tú padeces <br />
                y amas las almas <br />
                porque almas de tu Alma son <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>28 DE NOVIEMBRE DE 1995</h6>
              <p>
                Dice Jesús: <br />
                <br />
                Nada negaré al alma que pida con confianza al SACRATISIMO
                CORAZON EUCARISTICO DE JESUS <br />
                Os llamo y os espero.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>28 de Noviembre de 1995</h6>
              <p>
                Hijos queridos: <br />
                Haced vuestro, mi “Cántico“. Alabad al Señor con él. Porque toda
                vez que lo hagáis, cantarán con ustedes Ángeles y Santos en el
                Cielo. <br />
                Amén. Aleluya. Amén. Aleluya. <br />
                <br />
                “Mi alma canta la grandeza del Señor, <br />
                y mi espíritu se estremece de gozo en Dios mi Salvador, <br />
                porque El miró con bondad la pequeñez de su servidora. <br />
                En adelante todas las generaciones me llamarán feliz, <br />
                porque el Todopoderoso ha hecho en mi grandes cosas: <br />
                ¡Su Nombre es Santo! <br />
                Su Misericordia se extiende de generación en generación <br />
                sobre aquellos que lo temen. <br />
                Desplegó la fuerza de su brazo, <br />
                dispersó a los soberbios de corazón. <br />
                Derribó a los poderosos de su trono <br />
                y elevó a los humildes. <br />
                Colmó de bienes a los hambrientos <br />
                y despidió a los ricos con las manos vacías. <br />
                Socorrió a Israel, su servidor, <br />
                acordándose de su Misericordia, <br />
                Como lo había prometido a nuestros padres, <br />
                en favor de Abraham y de su descendencia para siempre”.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>30 DE NOVIEMBRE DE 1995</h6>
              <p>
                Después que recibí la Sagrada Comunión Jesús dice: <br />
                <br />
                “Yo Soy el Bien Infinito que sufre por las almas. <br />
                Traedme almas a mi Corazón”.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>1 de Diciembre de 1995 (primer viernes)</h6>
              <p>
                Después de recibir la Sagrada Comunión Jesús dijo: <br />
                Yo Soy “EL SACRATISIMO CORAZON EUCARISTICO DE JESUS” <br />
                Acérquense a mi Corazón, no teman os favoreceré. Yo Soy el AMOR
                sin límites.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>
                1 de diciembre de 1995 (estando en oración la Santísima Madre
                dijo)
              </h6>
              <p>
                Amados hijos: <br />
                Os estoy hablando a todos ustedes en este tiempo de
                Misericordia. No lo dejen pasar sin acercarse a Dios. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>4 DE DICIEMBRE DE 1995</h6>
              <p>
                Hijos amados: <br />
                El Espíritu Santo, habita en vosotros, porque vosotros sois
                hijos de Dios. No viváis según vuestros cuerpos, sino según el
                Espíritu Santo, piensen, vivan según el Espíritu, Orando y
                pidiendo su fortaleza para conservar la Gracia. <br />
                Tengan ánimo mis hijos, permanezcan en oración. Yo los acompaño
                siempre. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>8 DE DICIEMBRE DE 1995</h6>
              <p>
                En este día tan especial, he venido mis hijos para regalarles,
                mi gran Amor por ustedes. Todo mi ser ha sido preservado
                purísimo por la Santa Trinidad. En mi seno purísimo se encarnó
                el Verbo Inmaculado y Santo, la Luz Infinita que alumbra a toda
                la eternidad. En este maravilloso plan de Amor de Dios para la
                salvación de toda la humanidad. <br />
                Mediten en esto mis hijos, pongan la luz en vuestros corazones,
                comiencen a brillar como antorchas. <br />
                Bendito, Alabado y Glorificado sea Dios.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>12 DE DICIEMBRE DE 1995</h6>
              <p>
                Se obediente hijita, cumple la misión, eres mensajera
                instrumento de fe. Obedece al Altísimo, para que pueblos y
                ciudades del mundo puedan subir más alto en el conocimiento del
                Amor de Dios. <br />
                Los pueblos lo alabarán. ¡No Temas! En la simpleza de tu corazón
                se revela el Señor. <br />
                Alabado sea el SACRATISIMO CORAZON EUCARISTICO DE JESUS.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>12 DE DICIEMBRE DE 1995</h6>
              <p>
                Amados hijos: <br />
                He venido para llevarlos por el camino de la verdadera vida que
                es “Jesús”. <br />
                Esta Madre vuestra les hará más fácil el camino. ¡Abrid los
                corazones!, escuchad mis mensajes, quiero que comencemos a
                caminar juntos, por el camino que conduce al Cielo. ¡Rezad el
                Santo Rosario! Alabad la Gloria de Dios con él. Gloria a Dios.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>13 DE DICIEMBRE DE 1995</h6>
              <p>
                ( después de la Sagrada Comunión) <br />
                <br />
                Jesús dice: <br />
                “Yo Soy el eterno Amante de las almas”. Mirad la Gloria de mi
                Divino Corazón, encendido con el fuego del Amor por ustedes,
                expuesto a todas las miradas.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>17 DE DICIEMBRE DE 1995</h6>
              <p>
                Queridos hijos: <br />
                Os traigo la luz que ya tenéis en vuestro interior, pero que no
                la podéis ver a causa de vuestros pecados, os voy a ayudar a que
                puedan ver la luz de Cristo en vuestros corazones. <br />
                La obra de MISERICORDIA del Señor para con este pueblo, cruzará
                las fronteras y se esparcirá por el mundo entero. <br />
                Hijitos ¡Conviértanse! Todos. Atiendan mis enseñanzas, llega la
                Paz, llega el Amor, regocíjense por este llamado único y urgente
                de encontrar a Dios. <br />
                ¡Alabado sea el Señor!
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>19 DE DICIEMBRE DE 1995</h6>
              <p>
                Hijos queridos: <br />
                Adoren a mi Niño Jesús, como lo adoramos con José. Comiencen a
                adorarlo con el corazón, dejen que El comience a nacer en
                vuestros hogares en esta Navidad. <br />
                Os estoy hablando de una Gracia muy especial para vosotros mis
                queridos hijos, no la dejen pasar sin conversión. Los amo a
                todos. <br />
                Aleluya, Aleluya.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>27 DE DICIEMBRE DE 1995</h6>
              <p>
                Vuélvanse a Jesús queridos hijos, comiencen a mirarlo desde el
                momento que nace. Miren la pobreza en que nace el Salvador.{" "}
                <br />
                Comiencen a vivir con el Divino Niño Salvador, muriendo a
                ustedes mismos y naciendo a las cosas Celestiales. <br />
                Aleluya. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>27 DE DICIEMBRE DE 1995</h6>
              <p>
                Queridos hijos: <br />
                Os exhorto a que viváis como verdaderos Cristianos, HIJOS DE
                DIOS, y así vuestras obras sean, buenas y verdaderas;
                merecedoras del Reino de Dios. <br />
                Aleluya. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>28 de Diciembre de 1995</h6>
              <p>
                Oren hijitos día a día, para conocer el BIEN y rechazar el MAL.{" "}
                <br id="1996" />
                Amén. Aleluya.
              </p>
            </div>
          </div>
        </div>
        <EsquinerosAbajo />
        <EsquinerosArriba />
        <div className="container px-md-4" id="1996">
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Mensajes dados por <br /> La Santísima Virgen
              </h3>
              <h5>1996</h5>
              <h5>Salta - Argentina</h5>
            </div>
            <div className="col-12 mt-5">
              <h6>1 DE ENERO DE 1996</h6>
              <p>
                Amados hijos: <br />
                Quiero que comencéis junto a la Madre de Dios este año que se
                inicia. <br />
                Poned vuestros deseos en mi Corazón para que Yo como Madre de
                Jesús y Madre vuestra, pueda ayudarlos a que se realice en
                ustedes el Amor del PADRE, del HIJO y del ESPIRITU SANTO. <br />
                El Amor infinito de Dios, quiere ayudarlos a través mío a
                madurar en la FE, ESPERANZA Y CARIDAD. Para que en vuestras
                vidas se realicen las obras perfectas del AMOR DE DIOS que es
                Salvador. <br />
                Alégrense mis hijos, canten alabanzas a la Santa Trinidad.{" "}
                <br />
                ¡Conviértanse! <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 de Enero de 1996</h6>
              <p>
                Amados hijitos: <br />
                Rezad el Santo Rosario en familia, piensen que cuando hacen
                esto, Yo estoy acompañándolos. Comiencen ahora, con este nuevo
                año. Quiero estar en todos los hogares, para ayudarlos en todas
                las dificultades. Quiero que todos me conozcan. <br />
                Esta Gracia maravillosa os está regalando EL Señor, no
                permanezcáis indiferentes. ¡Os Amo a todos!. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE ENERO DE 1996</h6>
              <p>
                Oren unos por otros mis hijos, recuerden que Dios quiere lo
                mejor para vosotros. Sean solidarios en la oración con vuestros
                hermanos que sufren, después de pedir por vuestras necesidades
                pidan por otros. <br />
                Ustedes no viven solos, por el Amor Infinito de Dios tienen
                hermanos y deben compartir el Amor y la Paz del Señor. <br />
                Bendigan a Dios y bendigan a los hermanos, y así os haréis
                agradables a los ojos de Dios. Recibiréis grandes beneficios
                espirituales y la Paz de Dios vendrá a vuestros corazones.{" "}
                <br />
                Vivid esto, como os lo enseño. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE ENERO DE 1996</h6>
              <p>
                Hijos Amados: <br />
                Permanezcan unidos en oración al Todopoderoso, siéntanse
                hambrientos de su Amor y serán colmados del infinito Amor que
                todo lo puede. No dejen pasar este momento de Gracia. La
                infinita Misericordia los exhorta a una urgente conversión.{" "}
                <br />
                Conózcanse como hijos de Dios, escuchen su Palabra y dejen que
                penetre en vuestros corazones, imploren esta Gracia a su Divino
                Amor. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE ENERO DE 1996</h6>
              <p>
                María hijita de mi Corazón: <br />
                Orar con el Santo Rosario es estar cerca de mi Corazón, cada vez
                que lo rezas mi mirada permanece en ti, mi Corazón escucha y mi
                súplica se hace más insistente. <br />
                Soy puente de unión entre ti y la Santísima Trinidad. Te
                bendigo. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>11 DE ENERO DE 1996</h6>
              <p>
                ¡Orad! Hijos míos. ¡Orad! Con intenso amor, ya se ciernen las
                tinieblas sobre la Humanidad. ¡Tomad el arma! Que es el Santo
                Rosario. <br />
                Obedecedme hijos míos para que la Luz venza a las tinieblas.{" "}
                <br />
                <br />
                Amén. Amén. Amén. <br /> <br />
                La Santísima Virgen está toda de blanco y tiene su rostro bañado
                de Lágrimas y antes de hablarme permiteque mire su rostro.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>11 DE ENERO DE 1996</h6>
              <p>
                Jesús dice: <br />
                Con que derecho amonestáis a vuestros Sacerdotes, ¿no os enseñé
                a amaros unos a otros? <br />
                <br />
                Si vosotros sois mi pueblo y estáis corrompidos, cada uno de
                vosotros lleva una carga de pecado. Condonad primero vuestras
                deudas para que os perdone, sed verdaderos administradores míos
                para comenzar la obra de reparación en su justa medida, en el
                Santo Temor. Guardad las puertas de mi Reino con mi infinito
                Amor. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE ENERO DE 1996</h6>
              <p>
                Vi un campo seco, lleno de espinas y malezas, en el medio un
                jardín precioso, lleno de rosales con enormes rosas rosadas,
                contrastando con el campo. También gigantescos árboles de
                enormes copas, llenos de enormes rosas rosadas. <br />
                <br />
                Me dice La Madre: <br />
                Muchas dificultades os esperan en este momento. El precioso
                jardín es mi Corazón, en medio del mundo, las rosas representan
                a los que rezan el Santo Rosario, y ellos crecen como
                gigantescos árboles, elevándose al Cielo con muchos frutos
                espirituales. <br />
                El que me entrega su corazón y reza el Rosario no debe temer a
                nada de éste mundo, ya que ésta Santa oración los eleva por
                encima de toda dificultad y los protege especialmente de todo
                peligro, acercándolos con rapidez a Dios, creciendo
                interiormente, evitando ser contaminados de toda maldad. <br />
                Esta es la protección que Dios da a los que rezan el Santo
                Rosario. <br />
                <br />
                Predicad esto. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 DE ENERO DE 1996</h6>
              <p>
                Dice Jesús: <br />
                “Venid a Mí, todos los que estáis agobiados, os aliviaré de
                todas vuestras penas”. Venid a refugiaros en Mí Sagrado Corazón
                Eucarístico. <br />
                <br />
                Dice La Madre María Santísima: <br />
                Cuando habla Mi Divino Hijo, Cielos y Tierra se postran en
                adoración. Cada Palabra de Dios, tiene el peso de toda la
                eternidad. Obedecedle y alabadlo por medio de la oración. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 de Enero de 1996</h6>
              <p>
                Dice María Santísima: <br />
                A los jóvenes les digo: Que abran sus corazones a esta Madre del
                Cielo, para que os pueda enseñar, cual es el verdadero camino de
                la felicidad. Si dejáis que entre en vuestras vidas, os
                conduciré por el camino de rectitud, os mostraré la verdadera
                moralidad que debe haber en vuestras vidas; os enseñaré a ser
                puros de cuerpo y alma, para que conozcáis la verdadera alegría
                que nace del Corazón de Jesús, mi Divino Hijo. <br />
                Poned a Jesús en el centro de vuestras vidas. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE ENERO DE 1996</h6>
              <p>
                ¡Gracias por escucharme! <br />
                Os voy a pedir que viváis en oración alabando continuamente al
                Padre Celestial. Vosotros podréis hacer su Voluntad, si tenéis
                la fuerza y la luz que solo os dará el Espíritu Santo, por medio
                de la oración. <br />
                ¡Ayunad! Por lo menos una vez al mes, para comenzar. Ayunar
                significa privarse de algo por amor a Jesús. Ustedes no conocen
                el poder del ayuno y la oración. <br />
                ¡Comiencen a ayunar y a orar todos y el poder de las tinieblas
                será derrotado!. <br />
                Os amo a todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>1 DE FEBRERO DE 1996</h6>
              <p>
                Queridos hijos: <br />
                ¡Oren por la Paz!. Por la paz y el amor que debe reinar en cada
                hogar y en cada corazón. Especialmente la paz de los corazones.{" "}
                <br />
                ¡Convertíos enteramente al Señor!, busquen en todo cumplir su
                voluntad, que nada os detenga, luchen para conseguir esto en
                medio de las contrariedades. <br />
                Pónganse en oración, para que sepan discernir cual es la
                Voluntad de Dios en vuestras vidas y la realicen. <br />
                Encuentren la paz en vuestros corazones por medio de la oración.{" "}
                <br />
                Os amo a todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 DE FEBRERO DE 1996</h6>
              <p>
                Sois hijos amados y bendecidos por Dios, prestad atención a mis
                mensajes, pues en ellos os está llamando el Señor a una
                verdadera conversión. <br />
                Amén. Amén. <br />
                Leed el Salmo 14.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 DE FEBRERO DE 1996</h6>
              <p>
                Amados hijos: <br />
                ¡Yo soy vuestra Madre! Los invito a poner toda vuestra esperanza
                en el Señor. <br />
                Alaben a Dios constantemente, en todos los actos de vuestras
                vidas, crezcan interiormente por medio de la oración. Ustedes no
                pueden vivir con alegría si no tienen a Dios en sus corazones.
                Para vivir una verdadera vida Cristiana, comiencen a mirar a
                Jesús; compenétrense de las cosas divinas, hasta llenar por
                completo vuestros pensamientos y vuestros corazones del Amor de
                Dios. <br />
                Pongan interés en saber cuál es la Voluntad del Padre, orando
                con insistencia y ayunando. <br />
                Miren al hermano que sufre. Tiendan sus manos a los más
                necesitados, poniendo en vuestros corazones el deseo ardiente de
                orar por ellos. Y por este medio ustedes lograrán cosas
                increíbles del Amor de Dios. <br />
                ¡Fortalézcanse! en la oración y aumentará la paz en vuestras
                almas. <br />
                ¡Benditos sean! ¡Gloria al Altísimo!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE FEBRERO DE 1996</h6>
              <p>
                Hijos amados: <br />
                Sed verdaderos imitadores de Cristo, conforme a las enseñanzas
                que El os dejó. <br />
                ¡Abrid el Santo Evangelio! Y comiencen a dar Gloria a Dios.
                Conoced su Divina Palabra y lo que El manda. La Palabra de Dios
                no es para vivir de acuerdo al mundo, sino para prepararos a
                vivir en el Cielo. <br />
                ¡Alegraos mis hijos! El Señor es Misericordioso con los humildes
                de corazón, no dejéis pasar este momento tan especial. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE FEBRERO DE 1996</h6>
              <p>
                Queridos hijos: <br />
                Sed fuertes en el momento que os toca vivir, glorificad a Dios
                con vuestras vidas. Que cada momento del día sea alabado el
                Señor, cumpliendo con vuestras obligaciones y dando cada uno lo
                mejor de sí. <br />
                Obrad siempre con el Santo Espíritu de Dios, para que seáis
                vencedores y así vuestro Padre del Cielo os llamará a cada uno
                por su nombre y os conocerá como sus hijos. <br />
                Oren mis hijos queridos, oren. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>(LAS ROSAS) 11 DE FEBRERO DE 1996</h6>
              <p>
                ¡Orad mis hijos! Y creed en el Evangelio. <br />
                ¡Convertíos todos al Señor! Y todos los pueblos del mundo
                encontrarán la paz. <br />
                Orad intensamente, para que muchas almas se vuelvan al Señor.
                Orad por los enfermos, porque muchos de ellos sufren sin conocer
                el Amor de Dios, orad por ellos mis hijos orad. <br />
                Amén. Amén. Amén. <br />
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>12 DE FEBRERO DE 1996</h6>
              <p>
                Amados hijos: <br />
                Volved vuestros ojos a la Sagrada Eucaristía, fuente de vida
                fecunda y salud eterna. Conoced a vuestro Dios presente en todos
                los tabernáculos del mundo. Oren intensamente frente a Jesús
                Eucaristía. Pónganse en Sus Manos con sinceridad para que así
                Jesús que es todo Amor, pueda transformaros. Permaneced humildes
                y respetuosos en su presencia ¡El es Dios! Predicad esto. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE FEBRERO DE 1996</h6>
              <p>
                Venid mis hijos a mi Inmaculado Corazón. Este Corazón maternal
                será vuestra fortaleza. Yo siempre os resguardaré, “Os ofrezco
                mi Corazón Inmaculado lleno de Amor por vosotros”.
                <br />
                Amén. Aleluya Amén Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>14 DE FEBRERO DE 1996</h6>
              <p>
                Hijos míos: <br />
                Estoy triste por que muchos de ustedes sufren las consecuencias
                de este tiempo que viven, la mayoría trata de resolver los
                problemas lejos de Dios. Para muchos Dios no existe. <br />
                Este es tiempo de Misericordia os invito a vivir más
                profundamente en el Amor. Abrid vuestros corazones al Amor que
                es Jesucristo y El os escuchará y se apartarán de ustedes las
                tinieblas, se abrirán sus almas para recibir el Espíritu de
                Dios, y la Sabiduría Divina será vuestra consejera. Si queréis
                ser libres, reconciliaos pronto con Dios. <br />
                Os amo a todos, Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>16 DE FEBRERO DE 1996</h6>
              <p>
                Hijos míos amados: <br />
                Quiero que comprendáis cuan grande es el Amor del Padre del
                Cielo. Algunos de vosotros viven en completa oscuridad, mas por
                la Misericordia Divina, reciben el Amor de Dios, al igual que
                los que viven con la luz del Santo Espíritu. <br />
                Hijos míos he venido a traerles ESPERANZA, y así los que caminan
                en tinieblas sean iluminados. <br />
                No viváis las desventuras de este mundo, como si fuese el fin
                último. <br />
                Miradlo todo bajo la luz de la fe en la Palabra que os dejó
                Jesús, que todo lo sufrió, para que os mantengáis firmes en el
                camino que lleva al Cielo. <br />
                ¡Conviértanse todos! Para que sean iluminadores en el mundo,
                reflejando con vuestras vidas al Divino Corazón de mí Hijo
                Jesús. <br />
                ¡Gloria a Dios! Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE FEBRERO DE 1996</h6>
              <p>
                Oren al Señor con el Santo Rosario, invoquen la protección de
                Dios, mediante esta oración que es poderosa y pronto sentiréis
                en vuestras vidas la fuerza y la luz del Espíritu Santo. El
                Santo Rosario es el adorno más hermoso del alma, recurran a él
                en todo momento. <br />
                Yo estoy en el Santo Rosario, como Hija de Dios, Madre de Dios,
                Esposa de Dios y Madre amorosa de todos ustedes. <br />
                ¡Os amo mis hijos! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE FEBRERO DE 1996</h6>
              <p>
                En la oración hijitos míos ustedes permanecen unidos al Padre,
                al Hijo y al Espíritu Santo. <br />
                Cuando con vuestra oración dejáis la puerta abierta de vuestros
                corazones, al Amor infinito de Dios, ustedes reciben Gracias
                extraordinarias. <br />
                Amén Aleluya Amén Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>23 DE FEBRERO DE 1996</h6>
              <p>
                Amados hijos: <br />
                <br />
                Acercaos al infinito Amor del “Corazón Eucarístico de Jesús”.{" "}
                <br />
                Estos son tiempos de preparación. No perdáis tiempo en las cosas
                vanas de este mundo, desprendeos pronto de todo espíritu del
                mal. <br />
                Escuchad mis mensajes con espíritu de reflexión, os estoy
                hablando queridos hijos para que crezcáis espiritualmente, sed
                bondadosos y misericordiosos; confiad en la Infinita Bondad del
                Señor, para que con su Gracia seáis perseverantes en obrar
                siempre como buenos Cristianos. <br />
                “Volved vuestros ojos a Cristo Jesús”. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 DE MARZO DE 1996</h6>
              <p>
                Dice la Madre: <br />
                “Yo Soy la Gloria de este pueblo”
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 DE MARZO DE 1996</h6>
              <p>
                Hijos míos: <br />
                Que se manifieste en vosotros el Amor del Padre, el Sacrificio
                del Hijo y la Esperanza del Espíritu Santo. <br />
                Ofreceos a la Santísima Trinidad con vuestras obras y orando.
                Gozad de los bienes de este mundo, como de algo efímero y
                pasajero. Bendecid y agradeced a la infinita generosidad del
                Señor que os lo envía. <br />
                En este tiempo de preparación meditad la Palabra del Señor con
                profunda humildad para que seáis aceptados en el Cielo por
                vuestro Padre Dios que conoce vuestros corazones. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>4 DE MARZO DE 1996</h6>
              <p>
                Amados hijos míos: <br />
                Por el Amor de Dios estáis en el mundo. <br />
                Seguid al Señor y convertíos en este tiempo de gran Misericordia
                para vosotros. <br />
                Abrid los ojos a la Luz del mundo que es el Redentor. <br />
                Porque tiempo vendrá en que seréis llamados a juicio y después
                de esto, abismos hay que separan el bien del mal. <br />
                Mis hijos, el Cielo os espera a todos . Venid a mi Inmaculado
                Corazón y os conduciré a Dios. <br />
                Os amo intensamente. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE MARZO DE 1996</h6>
              <p>
                Que la paz y el Amor del Señor esté con vosotros amados hijos.{" "}
                <br />
                Hoy he venido a deciros que os mantengáis unidos y en oración.
                Esto se hará para combatir al maligno enemigo, que trata por
                todos los medios de quitarles la paz, especialmente la paz de
                los hogares. Sumiéndolos en el desaliento y la angustia, para
                alejarlos del Amor de Dios. <br />
                Orad por las calles con el Santo Rosario en desagravio al
                Inmaculado Corazón de María. <br />
                El Rosario es vuestra tabla de salvación. <br />
                Orad con fuerza los unos por los otros, ardiendo en caridad
                vuestros corazones por el hermano que sufre. <br />
                Poned toda vuestra esperanza en El Señor. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>6 DE MARZO DE 1996</h6>
              <p>
                Hijitos míos: <br />
                <br />
                Permaneced atentos al Amor de Dios. <br />
                Hoy he venido a deciros, qué quiere El Señor de su pueblo. Sed
                fieles hijos suyos, sabiendo cada uno como debe ser un verdadero
                Cristiano. <br /> <br />
                Bendecid al Padre, que con su Infinita Generosidad es paciente
                con vosotros. Escuchad la Palabra del Señor que es Palabra de
                Vida Eterna; y obrad conforme a ella para no tropezar. <br />
                <br />
                Los que abandonan el camino recto del Señor arrastran pesadas
                cadenas y no brilla la luz en sus corazones. Creced mis hijos en
                su Santa Sabiduría y os uniréis a vuestro Dios. Predicad esto.{" "}
                <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>6 DE MARZO DE 1996</h6>
              <p>
                “Consagraos todos al Sacratísimo Corazón Eucarístico de Jesús”.
                Es un llamado urgente del Amor de Dios. <br />
                Sean obedientes mis hijos. <br />
                “Yo soy la Madre de Dios”. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE MARZO DE 1996</h6>
              <p>
                Que se cumpla en vosotros el mandato del Señor “Sed Santos”.{" "}
                <br />
                Orad mis hijos por esta intención.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE MARZO DE 1996</h6>
              <p>
                Amados hijos: <br />
                <br />
                Alzad vuestros ojos al Cielo y pedid al Señor en su Divina
                MISERICORDIA que os dé corazones arrepentidos. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE MARZO DE 1996</h6>
              <p>
                ¡No desfallezcáis!. Que no se doblen las rodillas ante el
                espíritu del mal. El Señor os pide conversión. Ayunad y haced
                penitencia. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>9 DE MARZO DE 1996</h6>
              <p>
                Amados hijos: <br /> <br />
                Sean responsables cada uno de su conciencia cristiana; para que
                viváis en plenitud la verdadera libertad que os dio el Señor.{" "}
                <br />
                Vivid el Evangelio según el Amor. Ayudaos unos a otros en el
                Amor. Y así cada uno recibirá lo necesario para que no os
                perdáis. Oren mis hijos por esta intención. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE MARZO DE 1996</h6>
              <p>
                Todos estáis llamados al encuentro amoroso con vuestro Padre
                Dios, predicad esto. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>14 DE MARZO DE 1996</h6>
              <p>
                Hijos míos: <br />
                Os exhorto a que miréis las maravillas de la creación del Padre.
                Bendecid y adorad su Santo Nombre, que todo lo creó con su
                Inmenso AMOR. <br />
                ¡Arrepentíos!. <br />
                Volved al rebaño del Señor y viviréis. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>15 DE MARZO DE 1996</h6>
              <p>
                Adorad el Santísimo Sacramento. Adoradlo con el corazón, con el
                alma y con todo el ser. Y así pedid con confianza y recibiréis
                mis amados hijos todo cuanto os falta para llegar a ser dignos
                hijos de Dios. Vivid vuestras vidas con el que es Infinito Amor,
                presente entre vosotros en la Sagrada Eucaristía. <br />
                Acercaos a su Mesa y comed todos de El. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 DE MARZO DE 1996</h6>
              <p>
                Amados hijos: <br />
                <br />
                No busquéis consuelos materiales, buscad consuelo en la oración.{" "}
                <br />
                Orad con fe en medio de las dificultades para ser fieles al
                Señor. <br />
                Vivid con esperanza en vuestros corazones. Refugiaos en mi
                Inmaculado Corazón y triunfaréis. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE MARZO DE 1996</h6>
              <p>
                ¡Alabado sea el Altísimo! <br />
                <br />
                Hijos míos: Os pido en este tiempo de conversión que
                reflexionéis sobre vuestras vidas, a la luz del Evangelio, que
                es Palabra de vida y santa Sabiduría. <br />
                Mirad vuestras conciencias y reconciliaos con Dios. <br />
                Levantad el espíritu hacia El Señor con verdadera contrición de
                corazón. <br />
                ¡Abrid vuestros corazones al Sacratísimo Corazón Eucarístico de
                Jesús! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>21 DE MARZO DE 1996</h6>
              <p>
                En este día tuve una visión de Jesús en oración. Es de noche y
                hay muchas estrellas en el Cielo. <br />
                Una voz me dice: ¡El, conoce a sus ovejas!. Entiendo esto con mi
                corazón. <br />
                El Señor conoce a todos y a cada uno, en tiempo y circunstancias
                de vida. <br />
                El buen Pastor es nuestra esperanza. EL nos busca, nos conoce y
                nos mira desde un tiempo de Eternidad. “Nos llama”. El que lo
                oye se acerca a su espíritu de Amor y El permanece en nosotros
                con su AMOR. <br />
                <br />
                ORACION <br />
                <br />
                Alma Salvadora de Jesucristo, consume mi alma hasta la última
                gota de deseo de mi misma y satisfácela con el ferviente deseo
                de Tú Amor por las almas. <br />
                Que las gotas de Tú Sangre Redentora caigan en mí corazón, lo
                transformen y arrebaten hacia tu Divino Corazón. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 MARZO DE 1996</h6>
              <p>
                Amados hijos: <br />
                <br />
                Hoy he venido a visitarlos con la misión de acercarlos a Jesús,
                mi Divino Hijo. Escuchad mis palabras y practicadlas con
                integridad y conciencia, poned vuestros corazones a mi
                disposición para que penetre en ellos con la luz del Espíritu
                Divino y podáis conocer a CRISTO JESUS, vuestro Salvador. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>27 DE MARZO DE 1996</h6>
              <p>
                Si queréis un mundo lleno de amor. “AMAD A DIOS SOBRE TODAS LAS
                COSAS”. <br />
                Amén
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 DE ABRIL DE 1996</h6>
              <p>
                María hija mía: <br />
                Debes soportar todas las pruebas con un gran amor a Jesús
                Crucificado. La gracia de Dios te acompañará. <br />
                Que los abundantes frutos de tu corazón sean dados a las almas
                más necesitadas, cuando estés en oración. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 DE ABRIL DE 1996</h6>
              <p>
                Hija mía: <br />
                Levanta tu corazón junto a la Cruz de mi HIJO para comprender
                todo el misterio de su Amor. <br />
                Permanece en la Cruz junto a Jesús y así tu corazón se colmará
                de bendiciones. <br />
                Esto es promesa de Dios. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>4 DE ABRIL DE 1996</h6>
              <p>
                JESUS dice: <br />
                <br />
                Contempladme y adoradme en mi Sacratísimo Corazón Eucarístico.
                Vosotros sois en MI, cuando coméis Mi Cuerpo y bebéis Mi Sangre;
                y mi infinito AMOR está en vosotros. <br />
                <br />
                Dice María Santísima: <br />
                En el milagro de la SAGRADA EUCARISTIA, ustedes penetran en la
                intensidad de la TRINITARIA LUZ.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE ABRIL DE 1996</h6>
              <p>
                Hija mía: <br />
                Entregarse al misterio de la Cruz es convertirse. Al abrazar la
                Cruz por amor a Jesús, lo amargo se vuelve dulce, el dolor gozo,
                la desesperación paz, el odio Amor. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE ABRIL DE 1996</h6>
              <p>
                A los pies de la Cruz y en la cruel agonía, la Gloria de Dios
                recibía la dolorosa Madre, cuando su Corazón se abría.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE ABRIL DE 1996 (DOMINGO DE RESURRECCIÓN)</h6>
              <p>
                ¡Gloria al Poder de Dios! <br />
                ¡Gloria al Espíritu Santo! <br />
                ¡Alegraos y Regocijaos en la Resurrección del Señor! <br />
                ¡Gloria a Dios! <br />
                ¡Gloria a Dios! <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE ABRIL DE 1996</h6>
              <p>
                Hijos Míos: <br />
                ¡Convertíos! a Dios permanentemente, sed reflejos de Jesús, y
                así los que os miren reconocerán en ustedes a verdaderos
                Cristianos. <br />
                Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>9 DE ABRIL DE 1996</h6>
              <p>
                Alimentaos de la Palabra de Dios permanentemente, procurad
                siempre hacer su voluntad. <br />
                Todo tiempo que pasa sin levantar vuestros ojos al Cielo es
                tiempo perdido. <br />
                Amén. Aleluya. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>10 DE ABRIL DE 1996</h6>
              <p>
                Trabajen con alegría mis hijos, en los campos del Señor, porque
                tiempo vendrá que recogeréis lo que habéis sembrado. <br />
                Sed humildes y perseverantes en pedir esta Gracia al Señor.{" "}
                <br />
                Aleluya. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE ABRIL DE 1996</h6>
              <p>
                (Hoy vi a la Santísima Virgen en profunda tristeza y aflicción,
                toda vestida de blanco y su perfectísimo rostro parecía bañado
                en sudor). <br />
                <br />
                Mis hijos: <br />
                Hoy he venido a pediros que oren y oren con gran urgencia por la
                Paz del mundo, que está seriamente amenazada por la iniquidad
                del terrible enemigo de Dios. <br />
                <br />
                Confiad en mi Inmaculado Corazón que os guiará en medio de
                terribles tribulaciones. Seré vuestra Consejera, no os apartéis
                de mi guía, no os separéis del Santo Rosario y orad
                permanentemente con él, Yo Soy vuestra Madre y como Madre os
                hablo. <br />
                <br />
                El mensaje que hoy os quiero transmitir es muy duro y difícil de
                entender para los que viven olvidados de que Dios existe, y aún
                de los que teniendo conciencia de Dios viven despreocupados de
                salvar sus almas, viviendo según la carne y el mundo. <br />
                <br />
                Terribles cosas os esperan mis hijos si no volvéis vuestros ojos
                a Dios, pues el tremendo castigo que Dios mandará al mundo va a
                comenzar. <br />
                <br />
                Os revelaré una parte de este y será para llevarlos a la oración
                y al sacrificio y así tengan la esperanza de mitigar con
                vuestros rezos, este castigo tan terrible. Esto es una
                advertencia llena del AMOR DE DIOS hacia la humanidad. <br />
                <br />
                Muchas almas religiosas caerán y se apartarán del camino del
                Señor para vivir en la tibieza del mundo. Los sacerdotes que
                queden no se diferenciarán en nada de los seglares, seguirán el
                camino del mundo que los llevará a la apostasía, las religiosas
                seguirán este mismo camino y muchas almas buenas se perderán por
                su causa. El mundo sin religión y sin Dios será morada de seres
                salvajes y animalezcos y cambiarán la fisonomía humana y así el
                cuerpo será el reflejo del alma. Estos aterradores humanos
                convertidos en discípulos de satanás aprovechando el caos que
                sobrevendrá por los grandes e inminentes castigos que caerán
                sobre el mundo, perseguirán a los buenos en feroz cacería. No
                habrá diferencia de sexos y por un tiempo determinado por Dios
                Padre el infierno reinará en el mundo. Pero mi INMACULADO
                CORAZON apartará las tinieblas y el horror, de mis hijos
                consagrados a Mí, El Señor esperará hasta último momento la
                conversión a mi Corazón Inmaculado, y así todos tendrán la
                oportunidad de salvarse y el perdón de Dios INFINITAMENTE
                MISERICORDIOSO. <br />
                <br />
                Oren, oren con intenso Amor. <br />
                “Sacratísimo Corazón Eucarístico de Jesús en Tí confío”.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE ABRIL DE 1996</h6>
              <p>
                No busquéis remedio para vuestros males, en las cosas del mundo.{" "}
                <br />
                ¡Aferraos al Santo Rosario!. <br />
                El Rosario os ha sido dado para consuelo y alegría vuestra.{" "}
                <br />
                Os hacéis muy agradables a Dios cuando lo alabáis con esta
                sencilla devoción. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>24 DE ABRIL DE 1996</h6>
              <p>
                Amados hijos: <br />
                <br />
                He venido a enseñarles el camino del Amor, que es Jesús. <br />
                El es Camino, la Verdad, la Vida, y el que lo ama de verdad no
                tropezará. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE ABRIL DE 1996</h6>
              <p>
                Amados hijos: <br />
                <br />
                Creed en Dios y no temáis nada. <br />
                Aceptad con Amor todo lo que Dios os envíe. <br />
                Vosotros tenéis vida por su Infinito Amor y Santa Voluntad; y
                esta vida se prolongará hasta la eternidad, si amáis a Dios
                sobre todas las cosas. Nada creó Dios en vano, sino que vanas
                son las cosas del mundo. <br />
                El INFINITO AMOR DE DIOS en vosotros se prolonga mis hijos,
                purificaos de vuestros pecados, ¡Pronto!. <br />
                Acudid a la Santa Iglesia en busca de mi Divino Hijo Jesús y lo
                encontraréis. <br />
                ¡Ay! mis hijitos, aún no podéis comprender cuanto os ama vuestro
                Dios. Si conocierais su AMOR, moraríais de gozo. <br />
                ¡Aprended! mis hijitos y poned paz en vuestros corazones. <br />
                ¡Convertíos pronto!. <br />
                Os amo y bendigo a todos. <br />
                Amén. Amén. Amén
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>30 DE ABRIL DE 1996</h6>
              <p>
                Mis hijos: <br />
                Vosotros tenéis en este tiempo una gran responsabilidad; que es
                la de orar por la paz y el amor entre los hombres del mundo.{" "}
                <br />
                Si os amáis los unos a los otros habrá paz. <br />
                Podréis amar de verdad si os entregáis a la vida de oración, más
                aún, si hacéis de vuestras vidas una oración al Señor. <br />
                Renuncien a todos los excesos y no pequen. Abrid vuestros
                corazones a la Palabra de Dios y dejaos guiar por ella. <br />
                Reconoced a Dios mis hijitos arrodillaos frente a JESUS
                EUCARISTIA, dejaos salvar por El. <br />
                ¡Cuánto os ama Jesús! <br />
                Benditos sean mis hijos. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 DE MAYO DE 1996</h6>
              <p>
                ¿Qué puede afligiros mis hijos? <br />
                Si tenéis a vuestra disposición el “Amor Infinito de Dios”.
                Convertíos de verdad y nada os faltará. <br />
                ¡Orad al Cielo con constancia! <br />
                ¡Sed discípulos de Jesús! <br />
                Amén Aleluya Amén Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE MAYO DE 1996</h6>
              <p>
                (Dice María Santísima) <br />
                <br />
                “Yo Soy Vuestra Madre y Protectora”. <br />
                Mi misión es acercarlos al Amor de Jesús. <br />
                Quiero tener a todos mis hijos cerca de mi Corazón. <br />
                Orad con fe y esperanza a vuestro Dios. <br />
                Os amo a todos. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE MAYO DE 1996</h6>
              <p>
                Hoy tuve la siguiente visión: <br />
                <br />
                Vi una custodia con el Santísimo Sacramento, ella está en medio
                de una inmensa luz, multitud de Ángeles postrados en adoración
                la rodean totalmente, a los pies vi un rosario. Después de ésta
                visión vi a la Santísima Virgen toda vestida de blanco. Ella
                estaba en medio de la radiante luz que siempre la precede. Lleva
                puesta una corona de oro sobre la cabeza, sus manos juntas a la
                altura del pecho, y en ellas el Rosario que parece ser de oro.
                Su mirada permanece hacia abajo y dice: <br />
                <br />
                “Yo Soy la Reina del Santo Rosario”, os pido Oración, Sacrificio
                y Penitencia para que baje a vosotros la Paz y Misericordia del
                Altísimo. <br />
                Adorad a Jesús vuestro Dios, como lo adoran la multitud de
                Ángeles en el Cielo. <br />
                Rezad el Santo Rosario todos los días, en desagravio por los
                ultrajes y sacrilegios con que se ofenden al Sacratísimo Corazón
                Eucarístico de Jesús y al Inmaculado Corazón de María. <br />
                Oren con el corazón para que todos sean sanados espiritualmente.{" "}
                <br />
                El inmenso AMOR DE DIOS se está prodigando a vosotros mis hijos.{" "}
                <br />
                Atiendan a mis deseos y convertíos pronto (y separando sus manos
                dio la bendición) Os bendigo a todos. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>15 DE MAYO DE 1996</h6>
              <p>
                Hijos míos: <br />
                <br />
                ¡Invocad el Nombre del Señor!, no vayáis por el camino
                equivocado, acercaos a la verdad del Evangelio que es camino a
                la Vida Eterna. <br />
                Orad para que vuestros corazones estén gozosos y llenos de
                Esperanza y sean bendecidos por el Amor del Espíritu Santo.{" "}
                <br />
                Cuando ustedes oran mis hijos, El Señor está constantemente
                delante de vosotros, para que no vaciléis. <br />
                ¡Alabad la Gloria del Señor! <br />
                Aleluya. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>16 DE MAYO DE 1996</h6>
              <p>
                Bienaventurados los hijos que obran según el Amor del Espíritu
                Santo por que ellos serán vencedores de todo mal. <br />
                Permaneced en oración y pedid que la Luz del Señor no se aparte
                de vosotros. <br />
                ¡Convertíos mis hijos al Amor del ESPIRITU SANTO! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE MAYO DE 1996</h6>
              <p>
                ¡Bendito sea El Señor en su inmensa Gloria! <br />
                ¡Bendito sea su Amor que os trajo el Cielo! <br />
                Y Benditos seáis mis hijos por ser hijos de Dios. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 de Mayo de 1996</h6>
              <p>
                Dad gracias a Dios mis hijos amados, por todo lo que El os ha
                dado y confiad en su Bondad y Misericordia orando con confianza
                en todo tiempo. <br />
                A todos os escuchará. <br />
                Sed fieles al Señor que El os confortará y os fortalecerá con su
                Espíritu. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>22 DE MAYO DE 1996</h6>
              <p>
                Entregaos mis hijos al Señor con generosidad de corazón, no
                retacéis vuestra entrega. <br />
                El Señor conoce todo lo vuestro, y El os recompensará según
                vuestras obras. <br />
                Pedidle al Señor que os haga santos. <br />
                Dad gracias al Señor. Bendecid su SANTO ESPIRITU. <br />
                Alabado sea.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>24 DE MAYO DE 1996</h6>
              <p>
                Me dice Jesús: <br />
                <br />
                Quiero ser escuchado. <br />
                Te lo mando. <br />
                Habla al mundo de mi “Sacratísimo Corazón Eucarístico”. Que
                todos se acerquen a mi Infinito Amor con confianza. <br />
                <br />
                Dice la Santísima Madre: <br />
                Volved vuestros ojos a Jesús Eucaristía, alimentaos con el Amor
                de su Sagrado Corazón, escuchad y amad a vuestro Dios. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE MAYO DE 1996</h6>
              <p>
                ¡¡Benditos sean mis hijos!! <br />
                Hoy he venido a traerles la Bendición y el Amor del Padre, del
                Hijo y del Espíritu Santo, para que todos os convirtáis. <br />
                Os acompañaré en el camino de la purificación, seré la luz que
                guíe vuestros pasos. <br />
                Consagraos al divino Corazón Eucarístico de Jesús y al
                Inmaculado Corazón de María y veréis brillar la luz en vuestros
                corazones. <br />
                La puerta está abierta mis hijos, venid a Mi y os acompañaré a
                cruzar el umbral. Gracias por escucharme. <br />
                Os amo a todos. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>4 DE JUNIO DE 1996</h6>
              <p>
                Hoy la Madre ha mostrado su Inmaculado Corazón. Y dice: <br />
                ¡Este es mi Inmaculado Corazón! <br />
                ¡Acercaos todos a El! <br />
                En estos tiempos de grandes pruebas para la humanidad, la luz de
                mi Corazón brillará en medio de la oscuridad. <br />
                No os abandonaré, sino que por medio de esta luz os guiaré con
                seguridad. Derretiré el hielo de muchos corazones fríos, con el
                calor de mi Amor, y así los que hayáis alcanzado la paz de Dios
                y os hayáis purificado de todas las inmundicias e idolatrías,
                seréis llamados a compartir el banquete Celestial como hijos
                verdaderos de Dios. <br />
                Os amo a todos. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE JUNIO DE 1996</h6>
              <p>
                ¡No tengáis temor!, que ninguna criatura se sienta abandonada de
                la mano de Dios, sino más bien alentados a ser robustos
                Cristianos en el mundo. <br />
                ¡Combatid! Sin miedos como elegidos de Dios, y hacedlo todo en
                su Nombre dando gracias y alabanzas a su Amor. <br />
                Vosotros sois hijos de la luz destinados a la salvación. <br />
                Predicad la Palabra de Dios y orad con constancia. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>6 DE JUNIO DE 1996</h6>
              <p>
                Hija: <br />
                Mi Divino Hijo Jesús, quiere que sea adorado, alabado y
                bendecido en toda la tierra, su SACRATISIMO CORAZON EUCARISTICO.{" "}
                <br />
                Que todos conozcan la Voluntad del Todopoderoso. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE JUNIO DE 1996</h6>
              <p>
                A mis jóvenes hijitos que están lejos del Amor del Señor os
                digo: <br />
                ¡Abrid los corazones! <br />
                No os dejéis contaminar por el espíritu del mundo, sino más bien
                satisfaceos de la bondad del Señor. <br />
                Levantad vuestros ojos al Cielo y orad con el corazón al Hacedor
                de todas las maravillas de la creación, y tomad conciencia de su
                Omnipotencia que os sustenta con su Infinito Amor. <br />
                Sentid constantemente su Santa Presencia en vuestros corazones.{" "}
                <br />
                ¡Benditos seáis mis amados! <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>9 DE JUNIO DE 1996</h6>
              <p>
                Dice María Santísima: <br />
                En este día tan importante debéis permanecer en constante
                oración, elevando vuestros corazones al Santo Espíritu de Dios y
                así podréis comprender la grandeza del Santísimo Sacramento.{" "}
                <br />
                El milagro más grande del Amor de Dios. <br />
                Alabado sea Dios por su gran Misericordia. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>14 DE JUNIO DE 1996</h6>
              <p>
                ¡Alabado sea el Señor!, en su Sagrado Corazón. <br />
                Amados hijos, os pido que meditéis con gran sinceridad sobre
                vuestras vidas, mirando profundamente en vuestros corazones.{" "}
                <br />
                Este es tiempo de Amor y Misericordia, que brota sin medida del
                Divino Corazón, todos sois llamados permanentemente. <br />
                ¡Abrid vuestras almas!. <br />
                El Divino Corazón os espera, no os demoréis. <br />
                Os amo y bendigo. Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE JUNIO DE 1996</h6>
              <p>
                Mis hijos purificad vuestros pensamientos, meditando siempre su
                Palabra. El que así procede tendrá la luz del Espíritu Santo en
                su corazón. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 DE JUNIO DE 1996</h6>
              <p>
                El que tiene a Dios en su corazón lo tiene todo, porque solo
                Dios lo puede todo. Meditad esto mis hijos. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>21 DE JUNIO DE 1996</h6>
              <p>
                Nada temas hija, he puesto en ti mi confianza, he apoyado mi
                mano en tu mano. <br />
                Predicad lo que habéis recibido con entera sinceridad y
                sencillez, no agreguéis ni quitéis nada que no os lo haya
                mandado el Señor. <br />
                Consagraos todos al Sacratísimo Corazón Eucarístico de Jesús.{" "}
                <br />
                Orad y meditad mis mensajes poniendo toda vuestra esperanza en
                el Señor. <br />
                Muchos serán los incrédulos, más la fuerza de Dios no os
                abandonará, el esfuerzo será grande. <br />
                Mi cercanía para con todos es una Gracia muy especial del Señor.{" "}
                <br />
                Sois favorecidos. Que dé mucho fruto.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>24 DE JUNIO DE 1996</h6>
              <p>
                María hija: <br />
                Así como tu me ves y escuchas, así de cerca estoy de todos mis
                hijos; dadlo a conocer, que todos se acerquen, con confianza a
                mi Corazón. <br />
                ¡Gloria al Altísimo!. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE JUNIO DE 1996</h6>
              <p>
                María: <br />
                Mira con atención mi rostro que es hoy reflejo de la alegría que
                hay en el Cielo; por que muchos corazones tibios vuelven a latir
                con amor. <br />
                Predica esto. <br />
                Yo Soy Madre de la Esperanza. <br />
                La doy al que la pide, <br />
                al que la busca, <br />
                al que no la conoce. <br />
                Yo soy la guía en el camino hacia la Esperanza que es Jesús.{" "}
                <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 DE JUNIO DE 1996</h6>
              <p>
                Amada hija: <br />
                Bendecida serás abundantemente en El Sacratísimo Corazón
                Eucarístico de Jesús. <br />
                Benditas serán tus obras y benditas serán las personas que te
                rodearán. <br />
                Bendito sea mi Divino Hijo Jesús en su Sagrada promesa. <br />
                ¡Gloria a Jesús! <br />
                ¡Santo, Santo, Santo!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>29 DE JUNIO DE 1996</h6>
              <p>
                En este día os digo mis hijos: <br />
                Amad profundamente a la Santa Iglesia. Orad por el Santo Padre
                todos los días unidos a mi Corazón. Predicad la Palabra y
                vividla con absoluta entrega. <br />
                Vivid por Cristo Jesús, con El y en El. <br />
                Uníos al Corazón de Jesús. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 DE JULIO DE 1996</h6>
              <p>
                Que Dios sea alabado y bendecido en todas sus criaturas. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 DE JULIO DE 1996</h6>
              <p>
                ¡Benditos sean mis hijos!. <br />
                ¡Benditos sean los solidarios y comprensivos!. <br />
                ¡Benditos sean los que son fieles al Sacratísimo Corazón
                Eucarístico de mi Divino Hijo Jesús!. <br />
                ¡Gloria al Señor!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>9 DE JULIO DE 1996</h6>
              <p>
                No teman mis hijos. Yo estoy con vosotros, Soy Fuente de Luz y
                Amor. <br />
                He apartado las tinieblas con la Luz de mi Corazón y así no
                seáis confundidos en estos tiempos de graves errores, caminen de
                mi mano para una urgente conversión. <br />
                Oren, Oren, Oren y ayunen dos veces por semana. <br />
                Prediquen y vivan mis mensajes y así ustedes verán grandes cosas
                en vosotros y en vuestras familias. <br />
                ¡Sean obedientes mis hijos!, comprendan bien esto. <br />
                Los amo y los bendigo. <br />
                Amén, Amén, Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE JULIO DE 1996</h6>
              <p>
                ¡Alabado sea El Señor!, en todas sus creaturas. <br />
                ¡Benditos sean los Cielos y la tierra!. <br />
                ¡Benditos sean mis hijos abundantemente!. <br />
                ¡Benditos sean vuestros Sacerdotes en el Sacratísimo Corazón
                Eucarístico de Jesús!. <br />
                Gloria, honor y adoración al Corazón Eucarístico de mi Divino
                Hijo Jesús presente en la Sagrada Eucaristía. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>16 DE JULIO DE 1996</h6>
              <p>
                ¡Benditos sean mis hijos!. <br />
                ¡Gracias por el amor de vuestros corazones!. Os invito a que
                viváis el amor de Jesús con un corazón humilde y así la intensa
                Luz de su Corazón os favorecerá y daréis mucho fruto. <br />
                Alégrense y den gracias al Señor que os ha mirado y elegido
                entre muchos para Gloria y Alabanza de su Santo Corazón,
                presente entre vosotros en la Sagrada Eucaristía. <br />
                Benditos sean, Benditos serán. <br />
                Predica esto. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE JULIO DE 1996</h6>
              <p>
                Amados hijos: <br />
                En este día os envío la paz de Mi Corazón, que os abrirá el
                camino hacia la conversión. <br />
                Os bendigo con la paz y el Amor de mi Corazón Inmaculado. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>28 DE JULIO DE 1996</h6>
              <p>
                ¡Gloria al Altísimo! <br />
                ¡Alabado sea El Señor! <br />
                <br />
                Amados hijos: <br />
                Os llevaré al Señor. Días plenos de felicidad os esperan a los
                que confían en mis palabras. <br />
                Benditos sean todos mis hijos. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>
                Amados hijos: <br />
                <br />
                ¡Bendecid al Señor!. <br />
                Bendecidlo con vuestros corazones llenos de amor hacia EL.{" "}
                <br />
                ¡Obedeced al Señor!. <br />
                Obedecedle con vuestros corazones llenos de amor hacia EL.{" "}
                <br />
                ¡Bendecid al Señor!. <br />
                Bendecidlo todo el tiempo y dadle gracias por su AMOR. <br />
                Adoren su Divina Voluntad y así sentiréis que el Espíritu de
                Dios permanece en vosotros. <br />
                Amén, Amén, Amén.
              </h6>
              <p></p>
            </div>
            <div className="col-12 mt-3">
              <h6>1 DE AGOSTO DE 1996</h6>
              <p>
                ¡Adoren a Dios!. <br />
                Solo ¡Adoren a Dios! mis hijos, miren al Cielo donde habita la
                Santísima Trinidad. <br />
                Adoren la SAGRADA EUCARISTIA, y clamen y rueguen en adoración en
                su Santa Presencia. <br />
                ¡Dios es Amor!. <br />
                Dios lo puede todo porque su Amor es infinito. <br />
                Benditos sean. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>15 DE AGOSTO DE 1996</h6>
              <p>
                “¡Yo soy vuestra Madre del Cielo!”. <br />
                Yo estoy en el Cielo en cuerpo y alma gloriosos. <br />
                Mis hijos hoy he venido especialmente a vosotros en este día de
                triunfo de mi Corazón Inmaculado, que vive y reina por toda la
                eternidad junto a la Santísima Trinidad. <br />
                ¡Gloria a Dios!. <br />
                ¡Alabada sea la Gloria del Señor!. <br />
                Bendigan en este día al Señor, alaben su grandeza. <br />
                Poned vuestros corazones junto al Sacratísimo Corazón
                Eucarístico de Jesús. <br />
                Que sean meditados mis mensajes, no los guarden en un cajón,
                lean, reflexionen y comiencen a orar al Espíritu Santo para que
                puedan hacerlos realidad en vuestras vidas. <br />
                Que reine en vosotros la Paz y el Amor de Jesús, los bendigo
                abundantemente. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE AGOSTO DE 1996</h6>
              <p>
                Hijos míos: <br />
                Oren al Espíritu Santo, ofrézcanle todas vuestras obras de cada
                día. <br />
                Si ustedes oran, recibirán santas inspiraciones para cada cosa
                que realicen. <br />
                Sean creyentes Santos, verdaderos templos de Jesús. <br />
                Os bendigo a todos. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 DE AGOSTO DE 1996</h6>
              <p>
                Amados hijos: <br />
                No busquéis la vana sabiduría del mundo, sino la Luz que viene
                de lo alto, donde mora la infinita y eterna sabiduría de Dios.{" "}
                <br />
                Vosotros lo tenéis todo porque Dios está con vosotros en la
                “SAGRADA EUCARISTIA”. <br />
                Poneos en oración y alabanzas ante vuestro Señor como hijos
                necesitados. <br />
                Experimenten esta gracia que es la esperanza. <br />
                Os amo y bendigo. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE AGOSTO DE 1996</h6>
              <p>
                Mis hijitos: <br />
                ¡Alabado sea Dios! <br />
                ¡Volved a los caminos del Señor!, por donde llegaréis seguros al
                Reino de Dios. <br />
                Yo soy vuestra Madre del Cielo y os amo. He venido a llamarlos a
                todos a una mayor vida de oración, para gustar de las cosas del
                Cielo. <br />
                Comiencen a orar Conmigo en este tiempo, que es tiempo de
                Esperanza y Misericordia. <br />
                No dejen pasar este momento, os bendigo a todos. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>22 DE AGOSTO DE 1996</h6>
              <p>
                ¡Levantaos mis hijos!. <br />
                Yo soy la Madre de Dios. <br />
                “¡Reina del Cielo y de la Tierra!”. <br />
                Consagraos todos al Inmaculado Corazón de María y así seré la
                Reina de vuestros corazones. <br />
                Si os consagráis, una fuerza poderosa se unirá a vosotros.{" "}
                <br />
                Os transformaré interiormente. <br />
                Seré permanente compañía en vuestras vidas y la Luz de Cristo
                brillará en vosotros. <br />
                Poned atención a mis palabras para que la semilla crezca y dé
                mucho fruto. <br />
                ¡Gloria al Altísimo!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 DE AGOSTO DE 1996</h6>
              <p>
                Orad mis hijos. Elevad a Dios vuestras oraciones apenas comience
                cada día. <br />
                Amparaos en la oración. <br />
                Encomendaos a Jesús y encomendad a vuestras familias. Pedid la
                protección de Dios para todos. <br />
                Tomad conciencia de que el maligno trata por todos los medios de
                alejarlos de Dios, poniendo temor y desánimo en vuestros
                corazones. <br />
                Fortaleceos en la Fe mediante la oración diaria. <br />
                ¡Alabado sea el Señor!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>27 DE AGOSTO DE 1996</h6>
              <p>
                Yo os amo mis hijitos y acudo presurosa a consolarlos cuando os
                acercáis a Mi con confianza. <br />
                Tenéis un medio poderoso de acercaros a mi Corazón; y es
                mediante el rezo del Santo Rosario. <br />
                Rezando esta gratísima devoción podéis conseguir Gracias. <br />
                ¡Pedid mis hijitos!. <br />
                Pedid la conversión de vuestros corazones y todo lo demás os
                será concedido. <br />
                Os bendigo. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>30 DE AGOSTO DE 1996</h6>
              <p>
                Mis hijos: <br />
                Sed verdaderos Cristianos, tomad conciencia de su significado.{" "}
                <br />
                Abrid el Santo Evangelio y conoced la Misericordia del Señor,
                para con vosotros. Dejad obrar al Espíritu Santo en vuestros
                corazones. <br />
                Nadie se salva por si mismo, sino por la gran Misericordia del
                Señor. <br />
                ¡Sea alabado mi Divino Hijo Jesús!. <br />
                ¡Sea por siempre alabado!. <br />
                Os bendigo. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 DE SETIEMBRE DE 1996</h6>
              <p>
                Hijitos. Que la caridad sea en vuestras vidas tan necesaria como
                el agua que han de beber. <br />
                Predicad esto. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 de Setiembre de 1996</h6>
              <p>
                ¡Alabad al Señor!. <br />
                Sed perseverantes y humildes. <br />
                ¡Invocad al Señor!, con constancia. <br />
                Disponeos a hacer el bien y evitar el mal. <br />
                ¡Confiad en el Señor!, El os protegerá. Levantad vuestros
                corazones, uníos a su Sagrado Corazón. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>4 DE SETIEMBRE DE 1996</h6>
              <p>
                Conviértanse mis hijos. <br />
                ¡Os exhorto a todos!. Vuelvan a Dios. Ya es tiempo de cosecha.{" "}
                <br />
                Hoy son bendecidos. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE SETIEMBRE DE 1996</h6>
              <p>
                Hijitos. Encended vuestros corazones de amor, orando sin cesar.{" "}
                <br />
                Ofreced ayunos y sacrificios para que haya Paz en el mundo.{" "}
                <br />
                Deseo que seáis pequeños instrumentos del Amor de Dios. Cumplid
                estos santos pedidos que os hago. <br />
                Rezad TODOS el Santo Rosario, arrodillaos humildemente y clamad
                al Cielo para que reine la Paz y el amor en el mundo. <br />
                Si vosotros oráis con el corazón la paz entrará en vuestras
                vidas, en vuestras familias y el Amor de Dios se hará visible en
                vosotros. <br />
                ¡No teman!. Estaré siempre velando y orando con vosotros. <br />
                Soy la Madre de Dios. Soy vuestra Madre. <br />
                ¡Benditos sean!. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE SETIEMBRE DE 1996</h6>
              <p>
                ¡Sean humildes mis hijos!. <br />
                Humildes de corazón. <br />
                Arrepentíos y confesad vuestras culpas. <br />
                ¡Abrid vuestros corazones! Id al encuentro de Jesús. <br />
                Nada hay más hermoso que un alma en GRACIA DE DIOS. <br />
                Jesús os ama en su Infinita Misericordia. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE SETIEMBRE DE 1996</h6>
              <p>
                Mis amados hijos: <br />
                En este día he venido especialmente a bendecirlos y a deciros
                que mi Corazón de Madre, está muy feliz, porque muchos de
                vosotros habéis comenzado a caminar Conmigo. <br />
                Vosotros sois elegidos a crecer en el Amor a Jesús, para Gloria
                y Alabanza de su Nombre. <br />
                Muchas dificultades os esperan, más con mi ayuda todo lo podrán.{" "}
                <br />
                Invocad al Señor en oración y experimentaréis su Misericordia
                que es tan inmensa que jamás os podréis imaginar. <br />
                Os bendigo a todos. <br />Y vi que la Ssma. Madre levantando su
                mano derecha junto con su Rosario, bendijo ampliamente mirando
                hacia abajo y sonriendo dulcemente.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>11 DE SETIEMBRE DE 1996</h6>
              <p>
                Hijitos: <br />
                ¡Sed como niños!. <br />
                Para que el Espíritu Santo pueda obrar en vosotros. <br />
                Sed caritativos y misericordiosos con los que sufren. <br />
                ¡Abrid vuestros corazones!. <br />
                Que la caridad nunca se acabe, que vosotros viváis siempre en el
                amor, y así seréis conocidos en el Cielo. <br />
                ¡Dios es infinito AMOR!. <br />
                Predicad esto. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE SETIEMBRE DE 1996</h6>
              <p>
                Hoy mientras estaba en oración vi a la Santísima Virgen que con
                gran esplendor y gloria bajaba del Cielo con Ángeles vestida de
                blanco, manto azul celeste y velo blanco. Con sus manos juntas
                en actitud de oración y una leve sonrisa en su hermosísimo
                rostro. <br />
                <br />
                Mi alma quedó elevada ante la solemnidad de la visión. Frente a
                la Ssma. Virgen apareció una estrella que brillaba como el sol.
                La Virgen Santísima se arrodilló en profunda adoración, después
                solo ví en medio de la luz dorada la SANTA HOSTIA y el Corazón
                herido de Jesús y la voz de la Ssma. Virgen que decía: <br />
                <br />
                “Bendito y adorado sea el Sacratísimo Corazón Eucarístico de
                Jesús”. <br />
                “Bendito y adorado sea el Sacratísimo Corazón Eucarístico de
                Jesús”. <br />
                “Bendito y adorado sea el Sacratísimo Corazón Eucarístico de
                Jesús”. <br />
                <br />
                Después de esto la Madre me dijo: <br />
                “SOY LA INMACULADA MADRE <br />
                DEL DIVINO CORAZON EUCARISTICO DE JESUS”. <br />
                <br />
                Le pregunté: <br />
                Así quieres ser nombrada?. <br />
                <br />
                y Ella dijo: <br />
                “Sí, así me conoceréis”. <br />Y luego con dulce sonrisa levantó
                su mano y bendijo ampliamente y ascendió.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>15 DE SETIEMBRE DE 1996</h6>
              <p>
                Dice el Señor: <br />
                “Si quieren ser Míos, vengan a MI”.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>16 DE SETIEMBRE DE 1996</h6>
              <p>
                Hijitos: <br />
                “Nos os preocupéis de las cosas mundanas, gustad de los bienes
                celestiales”. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE SETIEMBRE DE 1996</h6>
              <p>
                Mis hijitos: <br />
                Rezad el Santo Rosario con Amor. <br />
                Ofrecedlo a mi Corazón Inmaculado. De esta manera alcanzaréis
                sabiduría en las cosas de Dios, me conoceréis y conoceréis a
                Dios. <br />
                ¡Gloria al Altísimo!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 DE SETIEMBRE DE 1996</h6>
              <p>
                ¡Alaben al Señor!. <br />
                Perseveren en la oración y en las buenas obras. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>24 DE SETIEMBRE DE 1996</h6>
              <p>
                Hijitos míos: <br />
                “Los invito a celebrar esta fiesta dando gracias y alabanzas a
                Dios”. Y os exhorto a que abráis vuestros corazones a su Amor.{" "}
                <br />
                Orad al Espíritu Santo para que os dé Paz y fortaleza en este
                tiempo presente. <br />
                Yo Soy la Madre de Jesús y os traigo la Luz y la Esperanza.{" "}
                <br />
                Benditos sean mis hijos. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE SETIEMBRE DE 1996</h6>
              <p>
                ¡Benditos sean mis hijos! <br />
                ¡Benditos sean los que viven de acuerdo a la Palabra del Señor!{" "}
                <br />
                ¡Benditos sean los que superan todas las pruebas por amor de su
                Nombre! <br />
                ¡Benditos sean los que desprecian al príncipe del mundo y son
                fieles al Señor!. <br />
                En este día tan especial os animo, mis hijos a caminar en la
                esperanza, que es JESUS. <br />
                Purificad vuestros corazones y vivid como verdaderos hijos de
                Dios. Amando a Dios sobre todas las cosas. <br />
                Yo estaré siempre con vosotros. <br />
                Os amo intensamente. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>2 DE OCTUBRE DE 1996</h6>
              <p>
                Mis hijos: <br />
                Voy a suscitar un pueblo lleno de amor a Dios. <br />
                Obrad siempre el bien y despreciad al mal. Bendecid
                constantemente El Nombre de Dios y bendecíos unos a otros en el
                Nombre de Dios y así brillará siempre en vosotros la Paz y el
                Amor del Señor que está siempre entre vosotros presente en la
                Sagrada Eucaristía. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>3 DE OCTUBRE DE 1996</h6>
              <p>
                Hijitos míos, no entristezcáis mi Corazón perseverando en el mal
                camino. El Señor vuestro Dios está muy ofendido por tantos y
                abominables pecados que diariamente cometen y algunos ni se
                arrepienten de haberlos cometidos. Más por su Bondad y
                Misericordia Infinita el Señor es paciente con vosotros. <br />
                ¡Convertíos pronto mis hijos!. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE OCTUBRE DE 1996</h6>
              <p>
                Que mejor adorno para el alma, sobre todo para el alma en Gracia
                de Dios, que me honréis con el rezo diario del Santo Rosario.{" "}
                <br />
                Y cada vez que lo rezáis mis hijos, Yo estoy muy cerca, e
                intercedo ante Dios Nuestro Señor por vosotros. <br />
                ¡Bendito sea el Señor!. <br />
                ¡Benditos sean mis hijos!.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>10 DE OCTUBRE DE 1996</h6>
              <p>
                Mis hijos: <br />
                ¡No ofendáis más al Señor!. <br />
                Vosotros no participáis de la vida Cristiana. <br />
                Permanentemente buscáis satisfacciones mundanas, que hacen de
                vosotros Cristianos estériles, porque en esos placeres vanos no
                os encontráis con mi Divino Hijo Jesús. <br />
                Este vivir pensando en las cosas vanas deja en vuestros
                corazones, vacíos tremendos, imposible de llenar. <br />
                ¡Volved vuestras miradas al Señor!. <br />
                El Señor es todo vuestro y espera vuestra conversión verdadera.{" "}
                <br />
                Entregaos al Señor y confiad en El. El, es vuestra fortaleza.{" "}
                <br />
                Os amo a todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>12 DE OCTUBRE DE 1996</h6>
              <p>
                Dice la Santísima Virgen: <br />
                <br />
                Permanece triste mi Corazón, porque muchos hijos están lejos del
                Amor Misericordioso del Señor. <br />
                A pesar de que permanentemente son llamados. <br />
                Estos hijos han cerrado sus oídos y sus ojos y nada llega a sus
                corazones, muy endurecidos y fríos. Más el Amor de mi Corazón
                Inmaculado, insistirá hasta el fin por ellos. <br />
                Oren mis hijos, unos por otros y por ustedes mismos. <br />
                Alaben y bendigan al Señor. <br />
                Os amo a todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE OCTUBRE DE 1996</h6>
              <p>
                Prediquen siempre mis mensajes, sean obediente y vivan en paz
                con todos. <br />
                Alaben a la Divina Providencia y agradezcan todos sus
                beneficios. <br />
                Oren y ayunen por amor a Jesús y a su Santísima Madre pidiendo
                por la urgente conversión y la Paz del mundo. <br />
                Sean humildes y perseverantes al orar por la Paz del mundo.
                Haceos el firme propósito de rezar el Santo Rosario por estas
                intenciones. <br />
                No tardéis en predicar mis mensajes. <br />
                Os amo y os bendigo a todos. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>18 DE OCTUBRE DE 1996</h6>
              <p>
                Os pido corazones abiertos y generosos, y así podáis comprender
                esta gracia tan especial. Que os regala Jesús vuestro Salvador.{" "}
                <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE OCTUBRE DE 1996</h6>
              <p>
                Amados hijos: <br />
                Hoy deseo guiarlos hacia el Amor. <br />
                Deseo ofreceros el Amor de mi Corazón Inmaculado. Y a través de
                El os llevaré al Divino Corazón de Jesús. <br />
                Entregadle a esta Madre vuestros corazones y os llevaré a la
                total conversión. <br />
                ¡Den gloria a Dios!. <br />
                ¡Sea Alabado el Señor!.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 DE OCTUBRE DE 1996 (POR LA MAÑANA)</h6>
              <p>
                Amados hijos: <br />
                MI Corazón está muy triste porque muchos corazones están
                endurecidos y fríos y no pueden recibir el AMOR DE DIOS. A estos
                corazones nada conmueve y solo prestan atención a sus propios
                intereses. <br />
                Ellos están llenos de vanidad, ávidos de todos los honores del
                mundo, revestidos de una piedad de piedra. <br />
                Si supieran cuán grande es mi sufrimiento por estos hijos, que
                tanto se dañan a si mismos, no siendo dóciles al Amor del
                Espíritu Santo. <br />
                Escuchad el llamado de Dios y convertíos todos de verdad, cada
                día, cada hora, cada minuto y segundo que pasa, y así Vuestro
                Papá del Cielo los escuchará cuando lo invoquen. <br />
                ¡Bendito sea el Señor!. ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 DE OCTUBRE DE 1996 (POR LA TARDE)</h6>
              <p>
                Oren, Oren, por todos los que están lejos del Amor de Dios.{" "}
                <br />
                Prediquen y vivan mis mensajes abriendo vuestros corazones.{" "}
                <br />
                Reflexionen profundamente en ellos. <br />
                Todos sois mis hijos y deseo llevarlos a ser verdaderos
                servidores del Señor. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>21 DE OCTUBRE DE 1996</h6>
              <p>
                Hijos míos. Huid del materialismo y preferid a las cosas de Dios
                que son sobrias y sencillas. <br />
                Mientras más oréis al Espíritu Santo más sencillas serán
                vuestras vidas. Y la Paz y el Amor de Dios vivirá en medio de
                vosotros. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE OCTUBRE DE 1996</h6>
              <p>
                Mis hijos: <br />
                ¡Rezad el Santo Rosario todos los días!. <br />
                Pedid por las almas más alejadas del Amor de Dios. <br />
                Es necesario orar día a día para rescatar almas que se
                encuentran sumergidas en el pecado. <br />
                Orad por todos los enfermos y afligidos y así seréis
                instrumentos del Amor de Dios en el mundo. <br />
                En este día tan especial muchos hijos están mirando con
                confianza a mi Corazón maternal. Y mi Corazón escucha a todos
                los hijos que me aman y confían en mi poderosa intercesión. Más
                os digo: Todos sois escuchados por El Sagrado Corazón y
                especialmente hoy, todos seréis consolados y animados. <br />
                Yo, vuestra Madre he venido a fortalecerlos en el Amor a Jesús.{" "}
                <br />
                Obedeced mis mandatos sed dóciles a mis deseos y os prometo un
                cambio radical en vuestras vidas. <br />
                “Seguid al Señor”. El es Dios. <br />
                Benditos sean todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 DE OCTUBRE DE 1996</h6>
              <p>
                Hijos míos: <br />
                Que vuestras palabras no sean muchas, sino pocas y veraces,
                fundadas en el Santo Evangelio, para agradar a Dios y derrotar
                al enemigo. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>27 DE OCTUBRE DE 1996</h6>
              <p>
                Mis hijos: <br />
                ¡Alabado sea el Señor!. <br />
                ¡Alabada sea la Gloria del Señor!. <br />
                El Señor ha preparado vuestros corazones, para esta gran
                manifestación de su AMOR. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>5 DE NOVIEMBRE DE 1996</h6>
              <p>
                A vosotros mis hijos los que cargáis pesadas cruces, os digo que
                tengáis esperanza en el Señor. Que no desfallezcan vuestras
                fuerzas, no bajéis los brazos, perseverad en la oración al
                “Sacratísimo Corazón Eucarístico de Jesús”. Miradlo a El y
                ofrecedle todos vuestros sufrimientos y penas, y así os
                sentiréis aliviados y confortados por su AMOR. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>6 DE NOVIEMBRE DE 1996</h6>
              <p>
                Oren mis hijos por los que aún tienen el corazón cerrado, por
                los que se mantienen erguidos y satisfechos de sus vidas vacías.{" "}
                <br />
                ¡Cuántos de mis hijos persisten en el camino del mal!. <br />
                Oren para que el Señor derribe a los soberbios de corazón y
                vuelvan sus ojos al Salvador. <br />
                Oren y purifiquen vuestras conciencias. No perdáis tiempo.
                Bendecid el tiempo que permanece la LUZ del Señor con vosotros.{" "}
                <br />
                Den gracias a Dios por su inmenso Amor. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE NOVIEMBRE DE 1996</h6>
              <p>
                Amados hijos: <br />
                Yo estoy orando permanentemente por ustedes, intercedo ante la
                Santísima Trinidad para que el enemigo no perturbe vuestros
                corazones. <br />
                Oro para que conozcáis al Señor y toméis conciencia de la
                presencia real de JESUCRISTO EN LA SAGRADA EUCARISTIA. <br />
                Oro para que hagáis presente en vuestras vidas el Reino de Dios.{" "}
                <br />
                Mis hijos nada será posible sin El Señor, y todo lo conseguiréis
                con El. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE NOVIEMBRE DE 1996</h6>
              <p>
                ¡Benditos sean mis hijos! <br />
                Abundantemente sean bendecidos los que escuchan la Palabra del
                Señor y la practican. <br />
                Sean bendecidas las familias que son agradables al Señor. <br />
                Sean bendecidos los que sufren, los pobres y desvalidos. <br />
                ¡Benditos sean los que bendicen el Nombre de Dios!. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>9 DE NOVIEMBRE DE 1996</h6>
              <p>
                Hijitos amados: <br />
                ¡Visitad al Señor!. <br />
                Haced silencio en vuestros corazones frente al Sagrario. <br />
                Y El os enseñará. <br />
                Meditad esto. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>12 DE NOVIEMBRE DE 1996</h6>
              <p>
                Mis hijitos: <br />
                Hoy deseo invitarlos a orar en cada momento del día. Como Madre
                amorosa deseo llevarlos por el camino del Amor de Dios que os
                conducirá al Cielo. <br />
                ¡Abrid los corazones!. Y os conduciré al encuentro del Señor.{" "}
                <br />
                Si no os convertís es porque oráis poco o nada. <br />
                ¡Que inmenso es el Amor de mi Divino Hijo!. Dispuesto a perdonar
                al pecador arrepentido. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE NOVIEMBRE DE 1996</h6>
              <p>
                Mis hijitos: <br />
                Vivid de acuerdo al Santo Evangelio, haciendo el bien y
                aborreciendo el mal. Ya que todo bien procede de Dios y todo mal
                de satanás. <br />
                No os lastiméis de ninguna forma pues el Señor mismo recibe el
                dolor que a otros hacéis. <br />
                En estos tiempos el enemigo pondrá discordias y divisiones y él
                procurará sembrar el odio. <br />
                De esta forma el astuto enemigo permanecerá entre vosotros
                solapadamente. <br />
                Es por eso hijitos amados que os ruego que oréis permanentemente
                para que reconozcáis al Amor de Dios entre vosotros y mi
                presencia amorosa de Madre. <br />
                Los invito a la reconciliación profunda con el Señor, no os
                dejéis engañar por el orgullo. <br />
                Oren y ayunen para fortaleceros en las pruebas. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 DE NOVIEMBRE DE 1996</h6>
              <p>
                Hijos: <br />
                Rezad el Santo rosario y estaréis unidos a Mí. <br />
                Es necesario que os unáis a mi Corazón por medio de esta
                sencilla oración. Deseo que comprendáis esto: si poco rezáis
                poco estoy con vosotros. Si perseveráis en la oración sentiréis
                crecer en vuestro interior el deseo de amar al Señor, vuestro
                Dios. <br />
                De vosotros depende, os estoy esperando mis hijitos. <br />
                Meditad esto. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 DE NOVIEMBRE DE 1996</h6>
              <p>
                Le pregunto a la Madre si está contenta por el librito de los
                “Mensajes”; se lo muestro... Ella sonríe con gran felicidad y me
                dice: <br />
                <br />
                Mi Corazón se regocija de alegría junto con los Ángeles del
                Cielo, quién posea este librito con los mensajes poseerá mi
                Corazón, pues humildemente estoy en cada uno de ellos. <br />
                Habéis atraído sobre vuestro pueblo una lluvia de bendiciones.{" "}
                <br />
                ¡Alabado sea el Señor!. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 DE NOVIEMBRE DE 1996</h6>
              <p>
                Amados hijitos deseo compartir con vosotros la alegría de mi
                Inmaculado Corazón, con los que ya me conocen y caminan de mi
                Mano. <br />
                Deseo llegar a los corazones que no me conocen, para llevarles
                una nueva esperanza. Llevarlos a la Luz de Cristo Jesús, deseo
                llenar sus vidas de esperanza, enseñarles el camino del bien.{" "}
                <br />
                Poner Luz en las tinieblas, alegría en el dolor, salud en la
                enfermedad. <br />
                Deseo auxiliarlos, mis hijitos. ¡Aferraos a mi Purísimo
                Corazón!. Os estoy hablando mis hijos para que comiencen a orar
                junto a Mi. <br />
                Dios espera de vosotros urgente conversión. <br />
                Yo estoy con vosotros, mi misión de Madre es conducirlos por el
                camino que os lleva a Dios. <br />
                ¡Bendito sea el Señor!. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
              <p>
                <strong>(En un mensaje privado)</strong> <br />
                <br />
                ...Seguid predicando mis mensajes, y especialmente la devoción
                al SACRATISIMO CORAZON EUCARISTICO DE JESUS, no cejéis en este
                empeño, que cada alma se consagre a El, y así todos recibirán la
                Infinita Misericordia de su Corazón. Predicad su Consagración,
                avisando que toda alma a El consagrada, recibirá todas las
                Gracias que brotan de la Divina Misericordia del Señor. <br />
                <br />
                Esta Consagración, al Sacratísimo Corazón Eucarístico de Jesús,
                tendrá el sello de eternidad en las almas y obrará un cambio
                grande en ellas. Será la lleve que abrirá el alma para su
                conversión.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>27 NOVIEMBRE DE 1996</h6>
              <p>
                Hijos: <br />
                Oren con un corazón ferviente. No se dejen arrastrar por la
                tibieza. <br />
                “Amar a Dios es orar profundamente para El”. <br />
                Os amo y os bendigo. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>28 DE NOVIEMBRE DE 1996</h6>
              <p>
                Amados hijos: <br />
                Hoy los invito a que preparéis vuestros corazones para la
                Navidad. Como Madre vuestra deseo aconsejarlos a que viváis este
                tiempo con mayor recogimiento. <br />
                Ayunad en penitencia y reparación por lo menos dos veces por
                semana los que gozáis de buena salud. Y así al llegar la Navidad
                gozaréis de paz y felicidad. Hacedlo todo en Nombre de Dios.{" "}
                <br />
                Os bendigo a todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>29 DE NOVIEMBRE DE 1996</h6>
              <p>
                Hijitos: <br />
                ¡Pedid al Señor el DON de la Fe!.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>30 DE NOVIEMBRE DE 1996</h6>
              <p>
                Hijos míos: <br />
                Que todos vuestros pensamientos permanezcan en Jesús. <br />
                Adoren a “Jesús” en la Sagrada Comunión. Entregaos totalmente a
                El. <br />
                Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>4 DE DICIEMBRE DE 1996</h6>
              <p>
                Mis hijos: <br />
                Aún estoy aguardando a muchas almas, que no se deciden. <br />
                ¡Confíen en mi intercesión! <br />
                Mi Corazón está ardiendo de Amor por ustedes. <br />
                ¡No temáis!, acercaos más, entregaos más a mi Corazón. Quiero
                ser más conocida, más amada, más venerada como la Inmaculada
                Madre del Divino Corazón Eucarístico de Jesús. <br />
                Predicad esto. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>6 DE DICIEMBRE DE 1996</h6>
              <p>
                ¡Alabado sea el Altísimo! <br />
                Benditos sean los que escuchan la Palabra del Señor. <br />
                Benditos sean los que Me escuchan. <br />
                Benditos sean los que luchan para vencer las maldades de este
                tiempo. <br />
                Benditos sean los que las vencen por amor del Nombre de Dios.{" "}
                <br />
                Mis hijos oren y amen al Corazón de mi Divino Hijo Jesús con
                todo lo que son. <br />
                Benditos sean. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>7 DE DICIEMBRE DE 1996</h6>
              <p>
                Mis hijitos: <br />
                Oren junto a mi Inmaculado Corazón. <br />
                Mi Corazón es la fuente de donde sacaréis las fuerzas necesarias
                para enfrentar todas las difíciles situaciones. <br />
                Benditos sean. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE DICIEMBRE DE 1996</h6>
              <p>
                ¡Alabado sea el Altísimo! <br />
                Mis hijos: <br />
                Hoy deseo orar con cada uno de ustedes, estar en cada corazón
                que me invoca rescatando las almas que están lejos del Corazón
                Divino de Jesús. <br />
                Soy bienaventurada por ser la Madre Inmaculada de Jesús. <br />
                Glorifiquen mis hijos a la Santísima Trinidad. <br />
                ¡Gloria al Padre! <br />
                ¡Gloria al Hijo! <br />
                ¡Gloria al Espíritu Santo! <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>11 DE DICIEMBRE DE 1996</h6>
              <p>
                Mis hijitos: <br />
                Sed santos, como Santo es el Señor. <br />
                Santificaos en el Amor. Consagrad vuestras almas generosamente
                al Señor, para que El disponga de vuestros corazones y alcancéis
                la plenitud de su AMOR por medio de esta Consagración. <br />
                Os amo y os bendigo. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE DICIEMBRE DE 1996</h6>
              <p>
                Mis Hijitos: <br />
                Orad por todas las personas que están sumidas en el dolor. Sed
                fieles al Evangelio de Jesús Nuestro Dios y Salvador. <br />
                En este tiempo de preparación para la Navidad, abrid vuestros
                corazones, de tal manera que Jesús pueda nacer en ellos y seáis
                mensajeros de la fe. <br />
                ¡Alabado sea el Señor! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>14 DE DICIEMBRE DE 1996</h6>
              <p>
                ¡Alabado sea el Señor! <br />
                Mis hijitos hoy deseo concederles bendiciones especiales y
                ofrecerles la alegría desbordante de mi Inmaculado Corazón.{" "}
                <br />
                Deseo regalarles gracias especiales Amor, Paz, Fortaleza para
                que comiencen a caminar hacia la santidad. <br />
                Deseo que seáis muy felices en este camino hacia la santidad, y
                así experimentaréis la santa alegría que procede de Dios. <br />
                Yo deseo ayudaros a que alcancéis esta felicidad. <br />
                Os espero a todos. <br />
                ¡Benditos sean! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>17 DE DICIEMBRE DE 1996</h6>
              <p>
                ¡Alabado sea mi Divino Hijo! <br />
                Obrad con misericordia mis hijos. Sed pacientes y comprensivos
                unos con otros. Esta forma de obrar es el deber de todo
                Cristiano. <br />
                Poned paz en vuestros corazones. <br />
                Huid de toda división y discordia no sea que deis lugar al
                adversario, y seáis utilizados por él. <br />
                Refugiaos en la oración y vuestro espíritu será inclinado hacia
                el bien. <br />
                Hijitos míos venced a la carne y al mundo constantemente. Esto
                lo lograréis, si estáis unidos a Jesús cada día en la “Sagrada
                Eucaristía”. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>20 DE DICIEMBRE DE 1996</h6>
              <p>
                Dice la Madre: <br />
                <br />
                “Bendito sea el Niño Dios, presente en la Sagrada Comunión”
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>22 DE DICIEMBRE DE 1996</h6>
              <p>
                Mis hijitos: <br />
                Preparad un pesebre en vuestros corazones, con corazón sincero.{" "}
                <br />
                Sean humildes y sencillos como niños para que puedan recibir al
                Salvador en vuestros corazones. <br />
                ¡Gloria a Dios!
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>23 DE DICIEMBRE DE 1996</h6>
              <p>
                Mis hijitos amados: <br />
                El Niño Dios está al alcance de todos. <br />
                Recibidlo con alegría y sin dobleces. <br />
                Bendecid al Padre del Cielo. <br />
                Glorificad a Dios Niño presente en la Sagrada Comunión <br />
                ¡Benditos sean todos! <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>24 DE DICIEMBRE DE 1996</h6>
              <p>
                María: <br />
                <br />
                En este día único e irrepetible en la historia del mundo,
                esperábamos con José temblando de frío y de amor, estábamos muy
                unidos y en profunda oración. Este fue el momento más Santo del
                mundo en que el Hijo de Dios iba a nacer. <br /> <br />
                Antes de nacer lo adoramos con José en el Tabernáculo de mi
                Purísimo Vientre, Hostia viva y Divina, dentro de mi Ser. <br />
                <br />
                Yo soy la primera adoradora junto a José, del Salvador
                ¿Comprendes hija mía este inmenso regalo del Padre en su
                infinito AMOR al género humano? <br />
                <br />
                El Corazón Divino de mi Niño latía dentro de mi ser, luego el
                Cielo se abrió y el Padre se hizo presente en el pobre Pesebre
                de Belén y recibió a su Hijo, luego el pequeño Niño Dios y
                Hombre fue puesto en mis brazos y con José mi esposo adoramos la
                presencia de la Santísima Trinidad. <br />
                <br />
                Noche de Amor, de oración, de adoración, de Paz. <br />
                Bendita seas hija de mi Corazón en el nombre del Padre del Hijo
                y del Espíritu Santo. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>26 DE DICIEMBRE DE 1996</h6>
              <p>
                ¡Glorias y alabanzas a la Santísima Trinidad! <br />
                ¡Adorad al Niño Dios que es la Luz del mundo! <br />
                Despertad hijitos, y comenzad a adorar el Corazón Divino del
                Niño presente en la Sagrada Comunión. Alimentaos de este Sagrado
                Pan y El os convertirá. <br />
                Vivid esta Comunión en cuerpo y alma y así aprenderéis a amar.{" "}
                <br />
                Soy la Inmaculada Madre de Dios y vuestra Madre. Yo estoy en el
                Corazón de mi Divino Hijo, el que confía en Mi llegará a Dios.{" "}
                <br />
                Sean benditos hoy abundantemente.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>29 DE DICIEMBRE DE 1996</h6>
              <p>
                Hijos si queréis merecer el Cielo despojaos de las riquezas que
                acumuláis en el corazón. <br />
                Hay tanta riqueza en algunos corazones que convertidos en bienes
                materiales harían empalidecer al mas rico del mundo. <br />
                Sed humildes mis hijos dentro del corazón, no acumuléis tesoros
                que no os servirán en el Cielo, pues por su peso no entraréis en
                él. <br />
                ¡Sean verdaderos humildes! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>30 DE DICIEMBRE DE 1996</h6>
              <p>
                Hijitos: <br />
                En este tiempo de conversión mirad que la soberbia y la envidia
                no os ciegue el corazón. Cuidaos de este enemigo tan dañino para
                el alma. A Dios no podéis engañar. <br />
                Glorifiquen a Dios con un corazón humilde. <br />
                Os bendigo a todos. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>31 DE DICIEMBRE DE 1996</h6>
              <p>
                Hija mía: <br />
                Ora, sonríe y bendice a todos tus hermanos. Que la paz de Dios
                sea tu permanente compañía. <br id="1997" />
                ¡Gloria a Dios!
              </p>
            </div>
          </div>
        </div>
        <EsquinerosAbajo />
        <EsquinerosArriba />
        <div className="container px-md-4">
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Mensajes dados por <br /> La Santísima Virgen
              </h3>
              <h5>1997</h5>
              <h5>Salta - Argentina</h5>
            </div>
            <div className="col-12 mt-5">
              <h6>1 DE ENERO DE 1997</h6>
              <p>
                ¡Yo soy la Madre de Dios! <br />
                He puesto mis ojos y mi Corazón en mis hijos de todo el mundo.{" "}
                <br />
                Guardo en mi Inmaculado Corazón a todos mis hijos dispersos en
                el mundo entero. <br />
                Por Voluntad del Señor permanezco con vosotros, para exhortarlos
                a una urgente conversión. <br />
                Oren mis hijitos, oren siempre, no se separen del Santo Rosario.{" "}
                <br />
                Hoy sean benditos y que descienda sobre todos mis hijos en el
                mundo entero la Paz, el Amor y la Bendición del Señor. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>8 DE ENERO DE 1997</h6>
              <p>
                Amados hijos: <br />
                Refugiaos en Mí que soy vuestra Madre amorosa. <br />
                <br />
                No busquéis soluciones momentáneas a vuestras preocupaciones,
                pensando como piensa el mundo, pues os cargaríais de inútiles
                cargas espirituales. Pensad que vosotros sois Hijos de Dios y
                servidores de Jesucristo. Mirad a su Divino Corazón Eucarístico,
                ofrecedle todo el amor de vuestros corazones y os sentiréis
                aliviados en vuestras cargas y preocupaciones y la Paz y la
                alegría volverá a vuestras vidas. <br />
                <br />
                Os Amo a todos inmensamente <br />
                Amén. Amén .Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>10 DE ENERO DE 1997</h6>
              <p>
                Mis hijos: <br />
                ¡Orad y ayunad! <br />
                Levantad el corazón al Cielo. <br />
                No prestéis atención a las cosas que no tienen importancia pedid
                fortaleza y perseverancia para orar. <br />
                No descuidéis la caridad hacia el prójimo, tened conciencia del
                Bien y cuidaos de satanás que se presenta seductor y mentiroso
                para tentarlos, si oráis, su poder no los alcanzará, Yo estoy
                orando por todos ustedes. <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>19 DE ENERO DE 1997</h6>
              <p>
                Hijos míos: <br />
                ¡Os estoy esperando! día a día. Acudid a Mí y amparaos en mi
                Inmaculado Corazón, deseo derramar en vosotros mis bendiciones.{" "}
                <br />
                Crece en vuestros corazones la necesidad de amor, porque ustedes
                mis hijos viven en un mundo donde lo material parece ser lo
                esencial para ser felices. <br />
                He venido a transformarlos interiormente con el calor de mi AMOR
                Maternal, Y comprendáis y améis el Divino Corazón de Jesús.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>21 DE ENERO DE 1997</h6>
              <p>
                Mis hijitos: <br />
                ¡Preparaos! en este tiempo de conversión. Abrid vuestros
                corazones con la oración. <br />
                Orad al Espíritu Santo para que su Luz y su Amor guíe vuestros
                pasos. <br />
                ¡Despertad! y orad constantemente y no sucumbiréis. <br />
                ¡Alabado sea Jesucristo! <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>24 DE ENERO DE 1997</h6>
              <p>
                NUESTRA PURISIMA MADRE SIEMPRE VIRGEN MARIA nos dice así: <br />
                <br />
                Deseo derramar en todos mis hijos inmensas Gracias, os pido
                oración constante, para este tiempo de conversión. <br />
                He venido a despertar en todos vosotros, verdadero amor al
                Señor. <br />
                Que la Paz y el Amor del Señor os acompañe y se extienda al
                mundo entero. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE ENERO DE 1997</h6>
              <p>
                Mis hijitos consagraos a mi Inmaculado Corazón. <br />
                <br />
                Predicad esta CONSAGRACION. <br />
                <br />
                “PURISIMA” Madre mía, quiero consagrarte mi CORAZON, mi
                VOLUNTAD, mi VIDA ENTERA. <br />
                Llévame al Corazón de tu Divino HIJO JESUS, para que EL habite
                en mí. <br />
                Quiero ser totalmente tuyo Madre mía y a partir de hoy servirte
                fielmente en lo que me mandes. <br />
                Sé dulce compañía en mi vida, no permitas que jamás me separe de
                Tí y en la hora de la muerte ven a buscarme para gozar de la
                eternidad en tu compañía. <br />
                “Bendita y alabada seas por siempre Madre mía”. <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>31 DE ENERO DE 1997</h6>
              <p>
                ¡Alabado sea el Señor!. <br />
                Benditos hijos míos, deseo fervientemente que oréis todos juntos
                al Espíritu Santo para que la fuerza de la oración impida las
                guerras, el hambre, el sufrimiento y los desastres en la
                naturaleza. <br />
                <br />
                No abandonéis vuestra vida cristiana, procuraos tiempo durante
                el día para orar, acordaos de este pedido mío, para que nazca en
                vuestros corazones el deseo de orar, y orad con fuerzas al
                Altísimo por esta misión, de manera que satanás no pueda ganar
                más almas. <br />
                <br />
                ¡Gloria a Dios! <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>25 DE FEBRERO DE 1997</h6>
              <p>
                Estaba rezando el Santo Rosario frente a la imagen de la Ssma.
                Virgen del Rosario y vi en su frente algo oscuro, la forma de
                esto era como de cruz. <br />
                Después de la Santa Comunión, la Ssma. Virgen me dijo. <br />
                <br />
                Hija: <br />
                La cruz de ceniza que ves en mi frente es signo de conversión y
                penitencia que os pido a todos mis hijos en este tiempo tan
                especial de Cuaresma. <br />
                Arrepentíos de vuestros pecados y purificad los corazones, no
                dejéis pasar los días. <br />
                ¡Preparaos para el Señor! <br />
                El os está llamando, id a su Sacratísimo Corazón, no lo ofendáis
                más. <br />
                En este día tan especial os bendeciré con el inmenso Amor de mi
                Corazón Inmaculado. <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>1 DE JUNIO DE 1997</h6>
              <p>
                (Solemnidad de Corpus Christi) <br />
                <br />
                Estando en oración vi a Nuestro Señor con gran magnificencia,
                gloria y esplendor. <br />
                El me llamó por mi nombre. <br />
                María: y dijo después ¡mírame...! <br />
                <br />
                Y vi en su pecho el impresionante Corazón de carne, rojo
                sangrante y palpitante. Sentí un inmenso calor como si estuviera
                dentro de una hoguera que me quemaba toda. Y a la vez una
                beatitud grande levantó mi alma hacia El. <br />
                <br />
                Comprendí que el Señor ¿no sé como? me había introducido en su
                Sagrado Corazón, allí sentí a la luz perfecta de Dios, la
                dulzura y suavidad de su AMOR. <br />
                <br />
                El Señor dijo: escucha con atención este mandato de mi Infinita
                Providencia. <br />
                Adoradme y honradme por sobre todas las cosas en reparación y
                desagravio por los ultrajes, olvidos y sacrilegios que
                diariamente se cometen en el mundo entero al Sacramento de mi
                Divino Amor. <br />
                <br />
                CONSAGRAOS A MI SACRATISIMO CORAZON EUCARISTICO Y AL INMACULADO
                CORAZON DE MARIA, QUE EL MUNDO ENTERO SEA CONSAGRADO. <br />
                <br />
                Que sea conocida, propagada y llevada a cabo la "Adoración al
                Santísimo Sacramento, como verdadera devoción a mi Corazón vivo
                y presente en la Sagrada Eucaristía". <br />
                <br />
                Es tan grande mi Amor por las almas hija mía, que abriré las
                puertas del Cielo a todo aquel que me reciba y me complazca.{" "}
                <br />
                <br />
                Te bendigo hija mía con la fuerza de mi AMOR.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>6 DE JUNIO DE 1997</h6>
              <p>
                (Solemnidad del Sagrado Corazón) <br />
                <br />
                El Señor dijo: <br />
                ¡Sed todos míos! Abandonaos todos a Mí. <br />
                ¡Confiad plenamente en Mí!. <br />
                Acudid al fuego de mi Infinita Caridad.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>16 DE JULIO DE 1997</h6>
              <p>
                ¡¡Benditos sean mis hijos en el Sacratísimo Corazón Eucarístico
                de Jesús!! <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>15 DE AGOSTO DE 1997</h6>
              <p>
                ¡Alabado sea El Señor!. <br />
                En este día tan especial, os bendigo mis hijitos. <br />
                Yo soy la Madre de Jesús y vuestra Madre del Cielo. <br />
                Haceos pequeños y humildes en este día y consagraos a mi
                Inmaculado Corazón. <br />
                ¡Convertíos mis hijos al Señor!. <br />
                Amaos los unos a los otros con un corazón sincero, que el perdón
                sea luz en vuestros corazones, y así el Señor os bendecirá
                abundantemente. <br />
                Abandonaos mis hijitos al Amor del Divino Corazón. <br />
                Consagraos todos a su Divino Corazón, con un corazón limpio y
                puro. Orad mis hijitos, orad por esta intención. <br />
                ¡Bendito y adorado sea el Divino Corazón!. <br />
                Permaneced en el Amor ardiente del Divino Corazón. <br />
                Benditos sean mis hijos. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>29 DE AGOSTO DE 1997</h6>
              <p>
                ¡Alabado sea El Señor!. <br />
                Si los hombres no se convierten y escuchan al Señor, muchas
                guerras y pestes azotarán a la humanidad, diles que vuelvan a
                Dios, que escuchen su Palabra, que recen el Santo Rosario, todos
                los días. Muchos corazones están muy endurecidos y muchos oídos
                permanecen sordos a mis mensajes. Deseo ser escuchada, orad por
                esta intención..."Oraré al Señor por tus intenciones". Bendita
                seas hija de mi Corazón. <br />
                <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h6>13 DE SETIEMBRE DE 1997</h6>
              <p>
                ¡Alabado sea Jesucristo! <br />
                En este día tan especial en que honráis a la{" "}
                <strong>Madre de Dios</strong> deseo derramar abundantes
                bendiciones a todos mis hijos, especialmente a aquellos que
                sufren y están afligidos. <br />
                <br />
                Deseo consolarlos y animarlos con el Amor de mi Purísimo
                Corazón. Acudid a la Madre, mis pequeños hijitos y todos serán
                saciados en el refugio de mi Corazón Inmaculado. <br />
                <br />
                En estos días los invito a orar con el corazón, recogedlo en el
                Amor del Divino Corazón de Jesús. <br />
                Orad para que se ablanden los corazones rebeldes. <br />
                Lean mis mensajes, léanlos con un <strong>corazón puro</strong>,
                ellos son un medio poderoso para llevarlos al Sacratísimo
                Corazón Eucarístico de Jesús, donde está la Salvación y
                Santificación de las almas. <br />
                Convertíos en verdaderos amigos de Jesús. <br />
                Predica esto, hija mía, predícalo al mundo entero. <br />
                ¡Benditos sean mis hijos!. <br />
                Amén. Aleluya. Amén. Aleluya.
              </p>
            </div>
          </div>
        </div>
        <EsquinerosAbajo />
        <EsquinerosArriba />
        <div className="container px-md-4" id="2003">
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Mensajes dados por <br /> La Santísima Virgen Maria <br /> con
                posterioridad 2003
              </h3>
              <h5>Salta - Argentina</h5>
            </div>
            <div className="col-12 mt-5">
              <p>
                Se publican los Mensajes dados desde Julio 1990 hasta Octubre
                1997, autorizados a imprimirse para uso privado de los Fieles
                por Monseñor Moisés Julio Blanchoud - Arzobispo de Salta- el
                30/10/97.
              </p>
              <p>
                Los Mensajes dados con posterioridad a Octubre 1997 están en
                proceso de análisis por parte de una Comisión Eclesiástica
                formada a tal efecto. <br />
                Actualmente, la Inmaculada Madre del Divino Corazón Eucarístico
                de Jesús sigue dando Mensajes en la ciudad deSalta, República
                Argentina.
              </p>
              <p>
                Se recuerda, que de conformidad con el decreto del Papa Urbano
                VIII y con la disposición del Concilio Vaticano II, el escritor
                no tiene la intención de adelantarse al juicio de la Iglesia en
                cuanto a la naturaleza sobrenatural de los acontecimientos y
                mensajes mencionados en estas páginas. Tal juicio concierne a la
                autoridad competente de la Iglesia, ante la cual el autor se
                somete plenamente. Las palabras tales como apariciones,
                milagros, y similares tienen en este sitio un valor de
                testimonio humano.{" "}
              </p>
            </div>
          </div>
        </div>
      </LayoutMensajesVirgen>
    </>
  );
}
